<template>
  <div class="project-create-container">
    <el-card shadow="hover" style="height: 100%">
      <template #header>
        <div class="card-header">
          <span class="title">{{ $t('message.ClientProjectDeailAdd.projectInfoConfig') }}</span>
        </div>
      </template>

      <!-- 项目基本信息 -->
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"        
        label-width="140px"
        label-position="right"
        class="project-form"
      >
        <!-- 顶部：项目基础信息 -->
        <div class="form-top-section">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item :label="$t('message.ClientProjectDeailAdd.projectName')" prop="name">
                <el-input 
                  v-model="formData.name" 
                  :placeholder="$t('message.ClientProjectDeailAdd.enterProjectName')" 
                  clearable 
                />
              </el-form-item>
            </el-col>              
            <el-col :span="12">
              <el-form-item :label="$t('message.ClientProjectDeailAdd.projectOptions')" prop="business_id">
                <el-select 
                  v-model="formData.business_id" 
                  :placeholder="$t('message.ClientProjectDeailAdd.selectBusiness')" 
                  disabled 
                  style="width: 100%"
                >
                  <el-option
                    v-for="business in businessList"
                    :key="business.id"
                    :label="business.name"
                    :value="business.id"                  
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="24">
            <el-col :span="12">
                <el-form-item :label="$t('message.device.company')" prop="companyName">
                <el-tree-select
                  v-model="formData.companyId"
                  :data="companyTreeData"
                  :props="treeProps"
                  :placeholder="$t('message.device.selectCompany')"
                  check-strictly
                  clearable
                  filterable                  
                  @change="handleSearch"
                  :disabled="formData.currentProjectAddOrEdit === 2"
                />
              </el-form-item>
              </el-col>
            

            <el-col :span="12">
              <el-form-item :label="$t('message.ClientProjectDeailAdd.projectDescription')" prop="description">
                <el-input 
                  v-model="formData.description" 
                  :placeholder="$t('message.ClientProjectDeailAdd.enterProjectDescription')" 
                  clearable 
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('message.ClientProjectDeailAdd.projectLocation')" prop="location" v-if="false">
                <el-input 
                  v-model="formData.location" 
                  :placeholder="$t('message.ClientProjectDeailAdd.enterProjectLocation')" 
                  clearable 
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 中间：Tab配置区域  <el-tabs 
          v-if="tabsReady"  
          v-model="activeTab" 
          type="card" 
          editable 
          @tab-remove="removeTab"
          @edit="addTab" 
          class="slave-tabs"
          @tab-change="handleTabChange"
        > -->
        <div class="form-middle-section">
          <el-tabs 
            v-if="tabsReady"  
            v-model="activeTab" 
            type="card"
            editable
            @tab-remove="removeTab"
            @edit="addTab" 
            class="slave-tabs"
            @tab-change="handleTabChange"
          >          
       
           


            <!-- 业务块Tab页 -->
            <el-tab-pane
              v-for="tab in slaveTabs"
              :key="tab.name"
              :label="renderTabLabel(tab)"
              :name="tab.name"
              :closable="slaveTabs.length > 1"         
            >
              <!-- 参数模块配置内容 -->
              <div class="slave-config">
                <!-- 参数模块基本信息 -->
                <div class="config-header">
                  <el-row :gutter="24">
                    <el-col :span="8">
                      <el-form-item :label="$t('message.ClientProjectDeailAdd.parameterOptions')" prop="domainId">
                        <el-select 
                          v-model="tab.domainId" 
                          :placeholder="$t('message.ClientProjectDeailAdd.selectParameterOptions')"
                          style="width: 100%"
                          @change="handleDomainChange(tab.name)" 
                        >
                          <el-option
                            v-for="item in domainOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>           
                    <el-col :span="8">
                      <el-form-item :label="$t('message.ClientProjectDeailAdd.parameterModule')" prop="label" v-if="true">
                        <el-input 
                          v-model="tab.label" 
                          :placeholder="$t('message.ClientProjectDeailAdd.parameterModuleName')" 
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <!-- 变量操作按钮和查询表单 -->
                  <el-row :gutter="20" class="action-buttons">
                    <el-col :span="12">
                      <div class="button-group">
                        <el-button 
                          type="primary" 
                          size="small"
                          @click="addVariable(tab.name)"
                          :icon="Plus"
                          v-if="tab.domainId>0"
                        >
                          {{ $t('message.ClientProjectDeailAdd.addVariable') }}
                        </el-button>

                        <el-button 
                          type="primary" 
                          size="small"
                          @click="importVariables(tab.name)"
                          :icon="Upload"
                          v-if ="false"
                        >
                          {{ $t('message.ClientProjectDeailAdd.importVariables') }}
                        </el-button>
                        
                        <el-button 
                          type="primary" 
                          size="small"
                          @click="searchVariables"
                          :icon="Refresh"
                          :loading="isLoading"
                          :title="$t('message.ClientProjectDeailAdd.refreshVariableList')"
                        >
                          {{ $t('message.ClientProjectDeailAdd.refreshVariables') }}
                        </el-button>

                        <el-button 
                          type="primary" 
                          size="small"
                          :loading="exportLoading"
                          @click="handleExport(tab.name)"
                          :icon ="Download"
                          v-if ="false"
                        >
                          {{ $t('message.ClientProjectDeailAdd.exportVariables') }}
                        </el-button>

                        <el-button 
                          type="danger" 
                          size="small"
                          @click="batchDeleteVariables(tab.name)"
                          :disabled="!tab.variables.length"
                          :icon="Delete"
                          v-if="tab.domainId>0"
                        >
                          {{ $t('message.ClientProjectDeailAdd.batchDelete') }}
                        </el-button>

                        <el-button 
                          type="success" 
                          size="small"
                          @click="exportCurrentPage"
                          :icon="Download"
                          :loading="exportLoading"
                        >
                          {{ $t('message.ClientProjectDeailAdd.exportCurrentPage') }}
                        </el-button>

                        <el-button 
                          type="warning" 
                          size="small"
                          @click="importSortData"
                          :icon="Upload"
                        >
                          {{ $t('message.ClientProjectDeailAdd.importSort') }}
                        </el-button>
                      </div>
                    </el-col>
                    
                    <el-col :span="12">
                      <div class="search-group">
                        <el-input
                          v-model="queryParams.name"
                          :placeholder="$t('message.ClientProjectDeailAdd.variableName')"
                          size="small"
                          clearable
                          class="search-input"
                          @keyup.enter="searchVariables"
                        />
                        <el-input
                          v-model="queryParams.display_name"
                          :placeholder="$t('message.ClientProjectDeailAdd.displayName')"
                          size="small"
                          clearable
                          class="search-input"
                          @keyup.enter="searchVariables"
                        />
                        <el-button 
                          type="primary" 
                          size="small"
                          @click="searchVariables" 
                          :icon="Search"
                          :loading="isLoading"
                          class="search-button"
                        >
                          {{ $t('message.ClientProjectDeailAdd.search') }}
                        </el-button>
                        <el-button 
                          type="primary" 
                          size="small"
                          @click="handleUpdateProject(tab.name)"
                          class="search-button"
                        >
                          {{ $t('message.ClientProjectDeailAdd.save') }}
                        </el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                
                <!-- 变量表格区域 -->
                <div class="table-main-area">
                  <div class="variable-table-container">
                    <el-table 
                      :data="displayedVariables"             
                      border 
                      style="width: 100%;"                     
                      @selection-change="handleSelectionChange(activeTab, $event)"
                      v-loading="isLoading"
                      :element-loading-text="$t('message.ClientProjectDeailAdd.queryingVariables')"                      
                      class="variable-table"
                    >
                      <el-table-column type="selection" width="55" />
                      <el-table-column   
                        prop="domainId" 
                        :label="$t('message.ClientProjectDeailAdd.parameterOptions')" 
                        min-width="80"                  
                        sortable
                        v-if="false"
                      />
                      
                      <el-table-column   
                        prop="id" 
                        :label="$t('message.ClientProjectDeailAdd.id')" 
                        min-width="80"
                        v-if="false"
                      />

                      <el-table-column   
                        prop="deviceName" 
                        :label="$t('message.ClientProjectDeailAdd.deviceName')" 
                        min-width="80"
                        sortable
                      />
                      <el-table-column 
                        :label="$t('message.ClientProjectDeailAdd.variableGroup')" 
                        prop="var_group_name"
                        min-width="80"
                        v-if="true"
                      />

                      <el-table-column   
                        prop="name" 
                        :label="$t('message.ClientProjectDeailAdd.variableName')" 
                        min-width="80"
                        sortable
                      />
                      
                      <el-table-column 
                        prop="display_name" 
                        :label="$t('message.ClientProjectDeailAdd.displayName')" 
                        min-width="80"
                        sortable
                      />

                      <el-table-column 
                        prop="value" 
                        :label="$t('message.ClientProjectDeailAdd.variableValue')" 
                        min-width="100"
                        sortable
                      />

                      <el-table-column 
                        prop="unit" 
                        :label="$t('message.ClientProjectDeailAdd.unit')" 
                        min-width="80"
                        sortable
                      />

                      <!-- 可编辑的排序列 -->
                      <el-table-column 
                        prop="var_sort" 
                        :label="$t('message.ClientProjectDeailAdd.sort')" 
                        min-width="100"
                        sortable
                      >
                        <template #default="{ row, $index }">
                          <el-input-number
                            v-model="row.var_sort"
                            :min="1"
                            :max="9999"
                            size="small"
                            controls-position="right"
                            style="width: 100%"
                            @change="(value) => handleSortChange(row, value,tab.name, $index)"                            
                          />
                        </template>
                      </el-table-column>

                      <!-- <el-table-column 
                        prop="var_sort" 
                        :label="$t('message.ClientProjectDeailAdd.sort')" 
                        min-width="80"
                      /> -->

                      <el-table-column 
                        :label="$t('message.ClientProjectDeailAdd.operations')" 
                        width="140"
                        fixed="right"
                      >
                        <template #default="{ $index }">
                          <!-- 上移按钮 -->
                          <el-button
                            size="small"
                            type="primary"
                            @click="moveUp(tab.name, $index)"
                            :icon="ArrowUp"
                            circle
                            v-if="tab.domainId>0"
                          />
                          <!-- 下移按钮 -->
                          <el-button
                            size="small"
                            type="primary"
                            @click="moveDown(tab.name, $index)"
                            :icon="ArrowDown"
                            circle
                            v-if="tab.domainId>0"
                          />
                          <el-button
                            size="small"
                            type="primary"
                            @click="editVariable(tab.name, $index)"
                            :icon="Edit"
                            circle
                            v-if="false"
                          />
                          <el-button
                            size="small"
                            type="danger"
                            @click="deleteVariable(tab.name, $index)"
                            :icon="Delete"
                            circle
                          />
                          <el-button
                            size="small"
                            type="danger"
                            @click="connectionVariable(tab.name, $index)"
                            :icon="Connection"
                            circle          
                            v-if="tab.domainId==3"                  
                          />
                        </template>           
                      </el-table-column>
                    </el-table>
                  </div>
                 
                  <!-- 分页 -->
                  <div class="table-footer">
                    <el-pagination
                      v-model:current-page="queryParams.pageNum"
                      v-model:page-size="queryParams.pageSize"
                      :page-sizes="[10,30,50,100,500,2000]"
                      :total="queryParams.total"
                      :disabled="isLoading"
                      layout="total, sizes, prev, pager, next, jumper"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      class="variable-pagination"
                    />
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>          
        </div>

        <!-- 底部：提交按钮区域 -->
        <div class="form-bottom-section">
          <div class="form-footer">
            <el-button type="primary" :loading="submitting" @click="submitForm">
              {{ $t('message.ClientProjectDeailAdd.submitProject') }}
            </el-button>
            <el-button @click="resetForm" v-if="false">
              {{ $t('message.ClientProjectDeailAdd.reset') }}
            </el-button>
            <el-button @click="previewConfig" v-if="false">
              {{ $t('message.ClientProjectDeailAdd.previewConfig') }}
            </el-button>
          </div>
        </div>
      </el-form>
    </el-card>
  
    <!-- 变量选择弹窗 -->
    <el-dialog
      v-model="variableDialogVisible"
      :title="variableDialogTitle"
      width="90%"
      :close-on-click-modal="false"
      :draggable="true"
      class="variable-dialog"
      @closed="handleDialogClosed"
    >
      <div class="dialog-content-wrapper">
        <!-- 企业变量信息部分 --> 
        <el-form
          :model="searchForm"
          label-width="130px"
          class="search-form"
          inline
        >
          <el-form-item :label="$t('message.ClientProjectDeailAdd.companyDeviceTree')">
            <CustomTreeSelect
              v-model="selectedDeviceId"
              :external-device-id="currentDeviceId"
              :srcCompanyId = "formData.companyId"
              :tree-data="deviceTreeOptions"
              :placeholder="$t('message.ClientProjectDeailAdd.selectDevice')"                   
              :loading="loading"
              @change="handleDeviceChange"
              @node-click="handleNodeClick"
              class="filter-control variable-selector"
              style="width: 400px"
            />                
          </el-form-item>

          <el-form-item :label="$t('message.ClientProjectDeailAdd.slaveList')">          
            <el-select 
              v-model="currentSlaveId" 
              :placeholder="$t('message.ClientProjectDeailAdd.selectSlave')"
              style="width: 200px"
              clearable
              @change="handleSlaveChange"
            >
              <el-option
                v-for="item in slaveOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>            
          </el-form-item>
        
          <el-form-item :label="$t('message.ClientProjectDeailAdd.variableGroup')">
            <el-select
              v-model="selectedGroupIds"
              :placeholder="$t('message.ClientProjectDeailAdd.selectVariableGroup')"
              style="width: 200px"
              multiple
              collapse-tags
              collapse-tags-tooltip
              clearable            
              @change="handleGroupChange"
            >
              <el-option
                v-for="group in VarGroupOptions"
                :key="group.value"
                :label="group.label"
                :value="group.value"
              />
            </el-select>
          </el-form-item>             
          <el-form-item :label="$t('message.ClientProjectDeailAdd.displayName')">
            <el-input 
              v-model="currentVarName" 
              :placeholder="$t('message.ClientProjectDeailAdd.enterVariableNamePlaceholder')" 
              clearable 
              @change="handleNameInput" 
            />
          </el-form-item>    

          <el-form-item>
            <el-button 
              type="primary" 
              @click="handleQuery"
              :disabled="!currentDeviceId"
            >
              {{ $t('message.ClientProjectDeailAdd.search') }}
            </el-button>
          </el-form-item>    
        </el-form>
        
        <!-- 主表格 -->
        <el-table 
          ref="variableTableRef"
          :data="filteredVariables"
          border 
          style="width: 100%;"
          height="400"
          :row-key="getRowKey"
          @select="handleRowSelect"
          @select-all="handleSelectAll"
          @selection-change="handleTableSelectionChange"
          :default-sort="{ prop: 'varName', order: 'ascending' }"
          stripe
          highlight-current-row
          class="variable-dialog-table"
        >
          <el-table-column 
            type="selection" 
            width="55" 
            :reserve-selection="true"
          />

          <el-table-column   
            prop="varName" 
            :label="$t('message.ClientProjectDeailAdd.variableName')" 
            min-width="120"
            sortable
          >
            <template #header>
              <div class="column-header">
                <span>{{ $t('message.ClientProjectDeailAdd.variableName') }}</span>
                <el-tooltip :content="$t('message.ClientProjectDeailAdd.variableUniqueIdentifier')" placement="top">
                  <el-icon class="header-icon"><InfoFilled /></el-icon>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column 
            prop="display_name" 
            :label="$t('message.ClientProjectDeailAdd.displayName')" 
            min-width="120"
            sortable
          >
            <template #default="{ row }">
              <span :class="{ 'default-name': !row.display_name }">
                {{ row.display_name || row.varName }}
              </span>
            </template>
          </el-table-column>
          
          <el-table-column 
            prop="deviceName" 
            :label="$t('message.ClientProjectDeailAdd.belongingDevice')" 
            min-width="150"
            show-overflow-tooltip
          />
          
          <el-table-column 
            prop="name_group" 
            :label="$t('message.ClientProjectDeailAdd.variableGroup')" 
            min-width="100"
            sortable
          />
          <el-table-column 
            prop="description" 
            :label="$t('message.ClientProjectDeailAdd.description')" 
            min-width="150"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span :class="{ 'no-description': !row.description }">
                {{ row.description || $t('message.ClientProjectDeailAdd.noDescription') }}
              </span>
            </template>
          </el-table-column>
    
          <el-table-column 
            :label="$t('message.ClientProjectDeailAdd.operations')" 
            width="140"
            fixed="right"
          >
            <template #default="{ row }">
              <div class="action-buttons">
                <el-button
                  size="small"
                  type="primary"
                  link
                  @click="viewVariableDetail(row)"
                  :icon="View"
                  :title="$t('message.ClientProjectDeailAdd.viewDetails')"
                />
                <el-button
                  size="small"
                  type="success"
                  link
                  @click="toggleVariableSelection(row)"
                  :icon="isVariableSelected(row) ? Minus : Plus"
                  :title="isVariableSelected(row) ? $t('message.ClientProjectDeailAdd.removeFromSelection') : $t('message.ClientProjectDeailAdd.addToSelection')"
                />
              </div>                  
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 表格分页 -->
        <div class="table-footer">
          <div class="selected-count">
            {{ $t('message.ClientProjectDeailAdd.selected') }}：
            <span class="count-number">{{ selectedVariables.length }}</span> 
            {{ $t('message.ClientProjectDeailAdd.variables') }}
          </div>
          <el-pagination
            v-model:current-page="tablePagination.currentPage"
            v-model:page-size="tablePagination.pageSize"
            :total="tablePagination.total"
            :page-sizes="[10, 50, 100,500,3000]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleTableSizeChange"
            @current-change="handleTablePageChange"
            class="dialog-pagination"
          />
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <div class="footer-left">
            <span class="selected-info">
              {{ $t('message.ClientProjectDeailAdd.currentPageSelection') }}：
              {{ tableSelectedVariables.length }} / {{ filteredVariables.length }} 
              {{ $t('message.ClientProjectDeailAdd.variables') }}
            </span>
          </div>
          <div class="footer-right">
            <el-button @click="cancelSelection">
              {{ $t('message.ClientProjectDeailAdd.cancel') }}
            </el-button>
            <el-button 
              type="primary" 
              @click="confirmSelection"
              :disabled="selectedVariables.length === 0"
            >
              {{ $t('message.ClientProjectDeailAdd.save') }}{{ $t('message.ClientProjectDeailAdd.selected') }}
              （{{ selectedVariables.length }}{{ $t('message.ClientProjectDeailAdd.variables') }}）
            </el-button>
          </div>
        </div>
      </template>
    </el-dialog>

    <!-- 变量编辑弹窗 -->
    <el-dialog
      v-model="variableEditDialogVisible"
      :title="variableEditDialogTitle"
      width="75%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="variableFormRef"
        :model="currentVariable"
        label-width="130px"
        :rules="variableRules"
      > 
        <el-divider content-position="left">{{ $t('message.ClientProjectDeailAdd.basicInfo') }}</el-divider>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item :label="$t('message.ClientProjectDeailAdd.variableName')" prop="name">
              <el-input 
                v-model="currentVariable.name" 
                clearable
                :placeholder="$t('message.ClientProjectDeailAdd.enterVariableName')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.ClientProjectDeailAdd.displayName')" prop="display_name">
              <el-input 
                v-model="currentVariable.display_name" 
                clearable
                :placeholder="$t('message.ClientProjectDeailAdd.enterDisplayName')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.ClientProjectDeailAdd.unit')" prop="unit">
              <el-input 
                v-model="currentVariable.unit" 
                :placeholder="$t('message.ClientProjectDeailAdd.unit')" 
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">{{ $t('message.ClientProjectDeailAdd.valueConfig') }}</el-divider>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item :label="$t('message.ClientProjectDeailAdd.variableValue')" prop="value">
              <el-input-number 
                v-model="currentVariable.value" 
                :min="0" 
                style="width:100%"
              />          
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.ClientProjectDeailAdd.coefficient')" prop="mult">
              <el-input-number 
                v-model="currentVariable.mult" 
                :min="0" 
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.ClientProjectDeailAdd.minimum')" prop="minimum">
              <el-input-number 
                v-model="currentVariable.minimum" 
                :min="0" 
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('message.ClientProjectDeailAdd.maximum')" prop="maximum">
              <el-input-number 
                v-model="currentVariable.maximum" 
                :min="0" 
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="variableEditDialogVisible = false">
            {{ $t('message.ClientProjectDeailAdd.cancel') }}
          </el-button>
          <el-button type="primary" @click="saveVariable">
            {{ $t('message.ClientProjectDeailAdd.save') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 联动规则编辑弹窗 -->        
  <el-dialog
    v-model="linkageDialogVisible"
    :title="linkageDialogTitle"
    width="800px"
    :close-on-click-modal="false"
  >
    <el-form
      ref="linkageFormRef"
      :model="currentLinkage"
      label-width="120px"
      :rules="linkageRules"
    >
      
     <!-- 第一行：已绑定变量显示 -->
    <el-form-item :label="$t('message.ClientProjectDeailAdd.boundVariable')">
      <div class="bound-variable-display">
        <div v-if="currentLinkage.linkageVars && currentLinkage.linkageVars.length > 0" class="linkage-vars-list">
          <div v-for="(linkVar, index) in currentLinkage.linkageVars" :key="index" class="linkage-var-item">
            <span class="var-name">{{ linkVar.target_var_name || $t('message.ClientProjectDeailAdd.unnamedVariable') }}</span>
            <el-button
              type="danger"
              size="small"
              circle
              :icon="Delete"
              @click="handleRemoveLinkageVar(index)"
              class="remove-btn"
              :title="$t('message.ClientProjectDeailAdd.removeLinkageVariable')"
            />
          </div>
        </div>
        <div v-else class="no-bound-variable">
          {{ $t('message.ClientProjectDeailAdd.noBoundVariable') }}
        </div>
      </div>
    </el-form-item>

      <!-- 第二行：联动类型和触发条件 -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('message.ClientProjectDeailAdd.linkageType')" prop="type">
            <el-select v-model="currentLinkage.type" style="width: 100%">
              <el-option :value="1" :label="$t('message.ClientProjectDeailAdd.fixedValueDispatch')" />
              <!-- <el-option :value="2" :label="$t('message.ClientProjectDeailAdd.multiVariableLinkage')" />
              <el-option :value="3" :label="$t('message.ClientProjectDeailAdd.formulaCalculation')" /> -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('message.ClientProjectDeailAdd.triggerCondition')" prop="condition_type">
            <el-select v-model="currentLinkage.condition_type" style="width: 100%">
              <el-option :value="1" :label="$t('message.ClientProjectDeailAdd.executeImmediately')" />
              <!-- <el-option :value="2" :label="$t('message.ClientProjectDeailAdd.delayedExecution')" />
              <el-option :value="3" :label="$t('message.ClientProjectDeailAdd.executeWhenConditionMet')" /> -->
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 变量搜索 -->
      <el-form-item :label="$t('message.ClientProjectDeailAdd.searchVariable')">
        <div class="variable-search-container">
          <el-input
            v-model="variableSearchKeyword"
            :placeholder="$t('message.ClientProjectDeailAdd.searchVariablePlaceholder')"
            clearable
            @input="handleLinkSearchVariables()"
          >
            <template #append>
              <el-button :icon="Search" @click="handleLinkSearchVariables()" />
            </template>
          </el-input>
        </div>
      </el-form-item>

      <!-- 变量列表 - 使用圆形单选框 -->
      <el-form-item :label="$t('message.ClientProjectDeailAdd.variableList')">
        <div class="variable-table-container">
          <el-table
            ref="linkageTableRef"
            :data="filteredLinkVariables"
            border
            style="width: 100%"
            height="300"
            @row-click="handleLinkVariableRowClick"
          >
            <!-- 圆形单选框列 -->
            <el-table-column width="60" align="center">
              <template #default="scope">
                <el-radio
                  v-model="selectedLinkVariableId"
                  :label="scope.row.var_id"
                  @change="handleLinkRadioChange(scope.row)"
                  style="--el-radio-text-color: transparent;"
                >
                  <span style="display: none;">{{ scope.row.var_id }}</span>
                </el-radio>
              </template>
            </el-table-column> 

            <el-table-column 
              :label="$t('message.ClientProjectDeailAdd.deviceName')" 
              prop="deviceName"
              min-width="150"
            />

            <el-table-column 
              :label="$t('message.ClientProjectDeailAdd.deviceId')" 
              prop="deviceId"
              min-width="150"
              v-if="false"
            />

            <el-table-column 
              :label="$t('message.ClientProjectDeailAdd.variableName')" 
              prop="varName"
              min-width="150"
            />
            <el-table-column 
              :label="$t('message.ClientProjectDeailAdd.defaultValue')" 
              min-width="120"
            >
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.default_value"
                  :min="0"
                  :max="scope.row.max_value || 999999"
                  :precision="scope.row.precision || 2"
                  :step="0.01"
                  size="small"
                  style="width: 100%"                  
                  @change="(value) => handleDefaultValueChange(scope.row, value)"
                />
              </template>
            </el-table-column>            
          </el-table>
        </div>
      </el-form-item>

      <!-- 其他配置项 -->
      <el-row :gutter="20" v-if="false">
        <el-col :span="12">
          <el-form-item :label="$t('message.ClientProjectDeailAdd.targetVariableId')" prop="target_var_id">
            <el-input-number 
              v-model="currentLinkage.target_var_id" 
              :min="1" 
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item 
            :label="$t('message.ClientProjectDeailAdd.delayTime')" 
            prop="delay_seconds" 
            v-if="currentLinkage.condition_type === 2"
          >
            <el-input-number 
              v-model="currentLinkage.delay_seconds" 
              :min="0" 
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item 
        :label="$t('message.ClientProjectDeailAdd.triggerConditionExpression')" 
        prop="condition_expression"          
        v-if="currentLinkage.condition_type === 3"
      >
        <el-input 
          v-model="currentLinkage.condition_expression" 
          :placeholder="$t('message.ClientProjectDeailAdd.expressionExample')"
          type="textarea"
          :rows="3"
        />
      </el-form-item>
      
      <el-form-item 
        :label="$t('message.ClientProjectDeailAdd.linkageContent')" 
        prop="action_content" 
        v-if="false && currentLinkage.type === 1"
      >
        <el-input 
          v-model="currentLinkage.action_content" 
          :placeholder="$t('message.ClientProjectDeailAdd.contentExample')"
          type="textarea"
          :rows="3"            
        />
      </el-form-item>
      
      <el-form-item 
        :label="$t('message.ClientProjectDeailAdd.linkageFormula')" 
        prop="action_formula" 
        v-if="currentLinkage.type === 3"
      >
        <el-input 
          v-model="currentLinkage.action_formula" 
          :placeholder="$t('message.ClientProjectDeailAdd.formulaExample')"
          type="textarea"
          :rows="3"            
        />
      </el-form-item>
      
      <el-form-item :label="$t('message.ClientProjectDeailAdd.ruleDescription')" prop="description" v-if="false">
        <el-input 
          v-model="currentLinkage.description" 
          :placeholder="$t('message.ClientProjectDeailAdd.enterRuleDescription')"
          type="textarea"
          :rows="2"
        />
      </el-form-item>
    </el-form>
    
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="linkageDialogVisible = false">
          {{ $t('message.ClientProjectDeailAdd.cancel') }}
        </el-button>
        <el-button type="primary" @click="saveLinkage">
          {{ $t('message.ClientProjectDeailAdd.save') }}
        </el-button>
      </span>
    </template>
  </el-dialog>

  </div>
</template>

<script setup>
import { ref, reactive, onMounted, defineProps, nextTick, computed, defineEmits, onBeforeUnmount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Plus, Delete, Search, Edit, Upload, Download, Connection, Refresh, InfoFilled, View, Minus,ArrowUp,ArrowDown } from '@element-plus/icons-vue'
import { getCompanyDeviceTree,getCompanyTree } from "@/api/CompanyManager"; 
import { getDevices } from '@/api/DeviceManagement'
import { slavedetailbydevice, vargroupdetailbydevice } from '@/api/TemplateManagement'
import { projectAdd, projectUpdate, projectCollectionsAdd, projectCollectionsUpdate,projectCollectionsDelete, projectAddBindVar,projectUpdateBindVar, projectCollectionsDomainVars, projectDeviceVarsList,DeleteProjectBindVarAsync, projectCollections,ProjectBindLinkageAdd,ProjectBindLinkageDelete} from '@/api/ProjectManger'
import CustomTreeSelect from '@/components/views/CompanyDeviceTree.vue'
import { useI18n } from "vue-i18n";
import {projectDomainList} from "@/api/ProjectManger";

// 添加这两个导入
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

const { t } = useI18n();
// 定义可以触发的事件
const emit = defineEmits(['save-success']);


const props = defineProps({
  companyId: {
    type: [String, Number],
    required: true
  },
  businessName: {
    type: [String, Number],
    required: true
  },
  businessId: {
    type: [String, Number],
    required: true
  },
  projectId: {
    type: [String, Number],
    required: true
  },
  projectName: {
    type: [String, Number],
    required: true
  },
  currentProjectAddOrEdit: {
    type: [String, Number],
    required: true
  },  
  slaveTabsData: {
    type: Array,
    default: () => []
  }
}); 


// 新增的响应式变量
const tabsReady = ref(false)
const variableEditDialogVisible = ref(false)
const variableEditDialogTitle = ref('')
const variableDialogVisible = ref(false)
const variableDialogTitle = ref('')
const variableFormRef = ref()
const variableTableRef = ref()

// 表格高度响应式控制
const tableHeight = ref('300px')
const variableSearchKeyword = ref('') // 变量搜索关键词
const alllinkVariables = ref([])
//const selectedLinkVariables = ref([]);
const selectedLinkVariableId = ref(0);
 

// 项目ID和集合ID
const projectId = ref(0)
const projectCollectionsId = ref(0)

const currentVariable = ref({
  id: 0,
  domainId: '',
  name: '',
  display_name: '',
  unit: '',
  value: 0,
  mult: 1,
  minimum: 0,
  maximum: 0,
})

// 变量搜索表单
const searchForm = reactive({
  deviceId: null,
  variableName: ''
})

// 表格搜索
const tableSearchText = ref('')
const filteredVariables = ref([])

// 表格分页
const tablePagination = reactive({
  currentPage: 1,
  pageSize: 500,
  total: 0
})

// 表格当前页选择
const tableSelectedVariables = ref([])

// 所有已选择的变量（跨页保持）
const selectedVariables = ref([]);

const currentDeviceId = ref();
// 存储当前选中的节点数据
const currentSelectedNode = ref(null);
const deviceTreeOptions = ref([]);

const currentDeviceInfo = ref({
  name: '',
  deviceCode: '',
  organization: '',
  template: '',
  gateway: '',
  address: '',
  tags: '-',
  description: ''
});
const currentSlaveId = ref(null)
const selectedGroupIds = ref([]);
const selectedGroupNames = ref([]);
const slaveOptions = ref([])
const VarGroupOptions = ref([])
const currentVarName = ref();

const deviceList = ref([]);

// 添加加载状态
const isLoading = ref(false)

// 查询群组信息参数
const queryVarGroupParams = reactive({
  deviceId: 0, 
  slaveId: 0,  
  name: ''
})

// 协议选项
const domainOptions = ref([  
  { value: 2, label: t('message.ClientProjectDeailAdd.operatingParameters') },
  { value: 3, label: t('message.ClientProjectDeailAdd.alarms') },
  { value: 5, label: t('message.ClientProjectDeailAdd.systemSettings') },
])

// 查询条件
const queryParams = reactive({
  name: '',
  display_name: '',
  pageNum: 1,
  pageSize: 500,
  total: 0
})

const queryCompanyTreeParams = reactive({
  companyId: null,
});
// 表单引用
const formRef = ref()
const linkageFormRef = ref()

// 业务列表
const businessList = ref([
  { id: 1, name: 'Digi-RTU', code: 'DIGI_RTU' },
  { id: 2, name: 'PSP-DXR', code: 'PSP_DXR' },
  { id: 3, name: 'PSP-DXW', code: 'PSP_DXW' },
  { id: 4, name: 'PSP-CIR', code: 'PSP_CIR' }
])

// 功能块列表
const domainList = ref([])

// 当前激活的Tab
const activeTab = ref('slave1')
const activeConfigTab = ref('domains')

// 表单数据
const formData = reactive({
  companyId:0,
  business_id: null,
  name: '',
  location: '',
  description: '',
  domains: [],
  bindings: [],
  linkages: [],
  currentProjectAddOrEdit:0
})

const companyTreeData = ref([]);

const treeProps = {
  value: "id",
  label: "name",
  children: "children",
};

// 业务块Tabs数据
const slaveTabs = ref([])

// 选中项
const selectedDomains = ref([])
const selectedBindings = ref([])
const selectedLinkages = ref([])

// 联动规则弹窗
const linkageDialogVisible = ref(false)
const linkageTabCurrentVerIndex = ref(0)

const linkageDialogTitle = ref('')
const currentLinkage = ref({
  id: null,
  type: 1,
  condition_type: 1,
  project_info_bind_id: 0,
  target_var_id: 0,
  target_device_id:0,  /// 目标设备ID
  target_var_value:0,
  target_var_name:'',
  delay_seconds: 0,
  condition_expression: '',
  action_content: '',
  action_formula: '',
  description: '',  
  editingIndex: null,
  linkageVars:[]
})


// 表单验证规则
const formRules = {
  name: [
    { required: true, message: t('message.ClientProjectDeailAdd.fillProjectName'), trigger: 'blur' }
  ],
  companyName:
  [
    { required: true, message: t('message.ClientProjectDeailAdd.fillProjectCompanyId'), trigger: 'blur' }
  ]
}

// 变量验证规则
const variableRules = {
  name: [
    { required: true, message: t('message.ClientProjectDeailAdd.enterVariableName'), trigger: 'blur' }
  ],
  display_name: [
    { required: true, message: t('message.ClientProjectDeailAdd.enterDisplayName'), trigger: 'blur' }
  ]
}

// 联动规则验证
const linkageRules = {
  type: [
    { required: true, message: t('message.ClientProjectDeailAdd.selectLinkageType'), trigger: 'change' }
  ],
  condition_type: [
    { required: true, message: t('message.ClientProjectDeailAdd.selectTriggerCondition'), trigger: 'change' }
  ],
  target_var_id: [
    { required: true, message: t('message.ClientProjectDeailAdd.enterTargetVariableId'), trigger: 'blur' }
  ]
}

// 提交状态
const submitting = ref(false)
const exportLoading = ref(false)

/*****排序相关****/
// ==================== 排序相关方法 ====================

// 导出当前页数据
const exportCurrentPage = async () => {
  const tab = slaveTabs.value.find(t => t.name === activeTab.value);
  if (!tab) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.selectModuleFirst'));
    return;
  }
  
  if (!tab.variables || tab.variables.length === 0) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.noDataToExport'));
    return;
  }
  
  try {
    exportLoading.value = true;
    
    // 准备导出数据
    const exportData = displayedVariables.value.map(variable => ({
      [t('message.ClientProjectDeailAdd.id')]: variable.id,
      [t('message.ClientProjectDeailAdd.variableName')]: variable.name,
      [t('message.ClientProjectDeailAdd.displayName')]: variable.display_name,
      [t('message.ClientProjectDeailAdd.deviceName')]: variable.deviceName,
      [t('message.ClientProjectDeailAdd.variableGroup')]: variable.var_group_name,
      [t('message.ClientProjectDeailAdd.variableValue')]: variable.value,
      [t('message.ClientProjectDeailAdd.unit')]: variable.unit,
      [t('message.ClientProjectDeailAdd.sort')]: variable.var_sort
    }));
    
    // 创建工作簿
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Variables');
    
    // 设置列宽
    ws['!cols'] = [
      { wch: 10 }, // ID
      { wch: 20 }, // 变量名
      { wch: 20 }, // 显示名
      { wch: 20 }, // 设备名
      { wch: 15 }, // 变量组
      { wch: 15 }, // 变量值
      { wch: 10 }, // 单位
      { wch: 10 }  // 排序
    ];
    
    // 导出文件
    const fileName = `${formData.name}_${tab.label}_${new Date().getTime()}.xlsx`;
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
    
    ElMessage.success(t('message.ClientProjectDeailAdd.exportSuccess'));
  } catch (error) {
    console.error('导出失败:', error);
    ElMessage.error(t('message.ClientProjectDeailAdd.exportFailed') + ': ' + error.message);
  } finally {
    exportLoading.value = false;
  }
};

// 导入排序数据
const importSortData = () => {
  // 创建文件上传input
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.xlsx, .xls, .csv';
  input.onchange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    try {
      // 读取文件
      const data = await readExcelFile(file);
      
      if (!data || data.length === 0) {
        ElMessage.warning(t('message.ClientProjectDeailAdd.noDataInFile'));
        return;
      }
      
      // 解析导入的数据
      const importData = parseImportData(data);
      
      if (importData.length === 0) {
        ElMessage.warning(t('message.ClientProjectDeailAdd.noValidSortData'));
        return;
      }
      
      // 显示确认对话框
      ElMessageBox.confirm(
        `${t('message.ClientProjectDeailAdd.confirmImportSort')}\n${t('message.ClientProjectDeailAdd.importCount')}: ${importData.length}`,
        t('message.ClientProjectDeailAdd.prompt'),
        {
          confirmButtonText: t('message.ClientProjectDeailAdd.confirm'),
          cancelButtonText: t('message.ClientProjectDeailAdd.cancel'),
          type: 'warning'
        }
      ).then(async () => {
        await batchUpdateSortByImport(importData);
      }).catch(() => {
        // 用户取消
      });
      
    } catch (error) {
      console.error('导入失败:', error);
      ElMessage.error(t('message.ClientProjectDeailAdd.importFailed') + ': ' + error.message);
    } finally {
      // 清理
      input.value = '';
    }
  };
  input.click();
};

// 读取Excel文件
const readExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);
        resolve(jsonData);
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};

// 解析导入的数据
const parseImportData = (data) => {
  const tab = slaveTabs.value.find(t => t.name === activeTab.value);
  if (!tab) return [];
  
  const importList = [];
  const sortField = t('message.ClientProjectDeailAdd.sort');
  const idField = t('message.ClientProjectDeailAdd.id');

  
  for (const row of data) {
    // 获取ID和排序值
    let id = null;
    let sortValue = null;
    
    // 尝试从不同的字段名获取ID
    if (row[idField] !== undefined) {
      id = parseInt(row[idField]);
    } else if (row.ID !== undefined) {
      id = parseInt(row.ID);
    } else if (row.id !== undefined) {
      id = parseInt(row.id);
    }
    
    // 获取排序值
    if (row[sortField] !== undefined) {
      sortValue = parseInt(row[sortField]);
    } else if (row.sort !== undefined) {
      sortValue = parseInt(row.sort);
    } else if (row.排序 !== undefined) {
      sortValue = parseInt(row.排序);
    }
    
    // 验证数据有效性
    if (id && !isNaN(id) && id > 0 && sortValue && !isNaN(sortValue)) {
      // 验证排序值范围
      if (sortValue >= 1 && sortValue <= 9999) {
        // 检查变量是否属于当前tab
        const existingVariable = tab.variables.find(v => v.id === id);
        if (existingVariable) {
          importList.push({
            id: id,
            var_sort: sortValue,
            name: existingVariable.name,
            oldSort: existingVariable.var_sort
          });
        }
      }
    }
  }
  
  return importList;
};

// 批量更新导入的排序
const batchUpdateSortByImport = async (importData) => {
  const tab = slaveTabs.value.find(t => t.name === activeTab.value);
  if (!tab) return;
  
  try {
    // 按ID创建映射
    const sortMap = new Map();
    importData.forEach(item => {
      sortMap.set(item.id, item.var_sort);
    });
    
    // 更新本地数据
    const variablesToUpdate = [];
    for (const variable of tab.variables) {
      const newSort = sortMap.get(variable.id);
      if (newSort !== undefined && newSort !== variable.var_sort) {
        variable.var_sort = newSort;
        variablesToUpdate.push({
          id: variable.id,
          var_sort: newSort,
          name: variable.name,
          visible: 1,
          var_group_name: variable.var_group_name || variable.name_group || '',
          description: variable.description || '',
          mult: variable.mult || 1,
          minimum: variable.minimum || 0,
          maximum: variable.maximum || 0,
          var_default_value: variable.value || variable.var_default_value || 0
        });
      }
    }
    
    if (variablesToUpdate.length === 0) {
      ElMessage.info(t('message.ClientProjectDeailAdd.noSortChanges'));
      return;
    }
    
    // 批量更新
    const result = await batchUpdateVariables(variablesToUpdate, tab);
    
    if (result.success) {
      ElMessage.success(`${t('message.ClientProjectDeailAdd.importSuccess')} ${variablesToUpdate.length} ${t('message.ClientProjectDeailAdd.variables')}`);
      
      // 可选：重新排序整个表格
      await reorderVariablesBySort(tab);
      
      // 刷新显示
      await searchVariables();
    } else {
      ElMessage.error(result.message || t('message.ClientProjectDeailAdd.importFailed'));
    }
  } catch (error) {
    console.error('批量更新导入排序失败:', error);
    ElMessage.error(t('message.ClientProjectDeailAdd.importFailed') + ': ' + error.message);
  }
};

// 根据排序值重新排序整个变量列表
const reorderVariablesBySort = async (tab) => {
  if (!tab || !tab.variables.length) return;
  
  // 按 var_sort 排序
  tab.variables.sort((a, b) => (a.var_sort || 0) - (b.var_sort || 0));
  
  // 重新整理排序值，确保连续
  let hasChanges = false;
  for (let i = 0; i < tab.variables.length; i++) {
    const expectedSort = i + 1;
    if (tab.variables[i].var_sort !== expectedSort) {
      tab.variables[i].var_sort = expectedSort;
      hasChanges = true;
    }
  }
  
  // 如果有变化，批量更新
  if (hasChanges) {
    const variablesToUpdate = tab.variables.map(v => ({
      id: v.id,
      var_sort: v.var_sort,
      varName: v.name,
      visible: v.visible !== undefined ? v.visible : 1,
      var_group_name: v.var_group_name || v.name_group || '',
      description: v.description || '',
      mult: v.mult || 1,
      minimum: v.minimum || 0,
      maximum: v.maximum || 0,
      var_default_value: v.value || v.var_default_value || 0
    }));
    
    await batchUpdateVariables(variablesToUpdate, tab);
  }
};

// 排序值变更处理（防抖）
const handleSortChange = async (row, newValue,tabName, index) => {
  
  //ElMessage.info(`${index}--newValue:${newValue}--row.var_sort:${row.var_sort}`);
  // 验证新值是否有效
  if (newValue === undefined || newValue === null ) {
    return;
  }
    
  // 限制范围
  if (newValue < 1) {
    row.var_sort = 1;
    newValue = 1;
    ElMessage.warning(t('message.ClientProjectDeailAdd.sortMinValue'));
  }
  if (newValue > 9999) {
    row.var_sort = 9999;
    newValue = 9999;
    ElMessage.warning(t('message.ClientProjectDeailAdd.sortMaxValue'));
  }
  
  // 检查是否与其他变量排序冲突（可选，根据业务需求决定是否启用）
  // const tab = slaveTabs.value.find(t => t.name === activeTab.value);
  // if (tab) {
  //   const conflict = tab.variables.some(v => v.id !== row.id && v.var_sort === newValue);
  //   if (conflict) {
  //     ElMessage.warning(t('message.ClientProjectDeailAdd.sortConflict'));
  //     // 恢复原值
  //     const oldValue = row.var_sort;
  //     row.var_sort = oldValue;
  //     return;
  //   }
  // }
  
  await updateSingleVariableSort(row, newValue,tabName, index);

  // 清除之前的定时器
  /*if (sortChangeTimer) {
    clearTimeout(sortChangeTimer);
  }
  
  // 延迟执行，避免频繁调用
  sortChangeTimer = setTimeout(async () => {
    await updateSingleVariableSort(row, newValue,tabName, index);
    sortChangeTimer = null;
  }, 500);*/
};

// 失去焦点时立即保存
// const handleSortBlur = async (row, newValue,tabName, index) => {
//   // 清除定时器
//   // if (sortChangeTimer) {
//   //   clearTimeout(sortChangeTimer);
//   //   sortChangeTimer = null;
//   // }
//   ElMessage.info(`newValue:${newValue}`);
//   // 验证并更新
//   if (newValue !== undefined && newValue !== null && newValue !== row.var_sort) {
//     await updateSingleVariableSort(row, newValue,tabName, index);
//   }
// };

// 更新单个变量的排序
const updateSingleVariableSort = async (srcVariable, newSort,tabName, index) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab) return;
  const variable = tab.variables[index];
  //ElMessage.info(`${index}--${variable.var_sort} -- ${variable.name}-newSort:${newSort}`);
  try {
    // 记录原始值
    const oldSort = variable.var_sort;
    
    // 更新本地值
    variable.var_sort = newSort;
    
    // 准备更新数据
    const updateData = {
      id: variable.id,
      var_sort: newSort,
      name: variable.name,
      visible: 1,
      var_group_name: variable.var_group_name || variable.name_group || '',
      description: variable.description || '',
      mult: variable.mult || 1,
      minimum: variable.minimum || 0,
      maximum: variable.maximum || 0,
      var_default_value: variable.value || variable.var_default_value || 0
    };
    
    // 调用后端接口
    const result = await batchUpdateVariables([updateData], tab);
    
    if (result.success) {
      ElMessage.success(`${t('message.ClientProjectDeailAdd.sortUpdateSuccess')} ${variable.display_name || variable.name}`);
      // 可选：重新排序整个表格
      //await reorderVariablesBySort(tab);
    } else {
      // 失败时恢复原值
      srcVariable.var_sort = oldSort;
      ElMessage.error(result.message || t('message.ClientProjectDeailAdd.sortUpdateFailed'));
    }
  } catch (error) {
    console.error('更新排序失败:', error);
    ElMessage.error(t('message.ClientProjectDeailAdd.sortUpdateFailed') + ': ' + error.message);
  }
};

// 根据排序值重新排序整个变量列表
// const reorderVariablesBySort = async (tab) => {
//   if (!tab || !tab.variables.length) return;
  
//   // 按 var_sort 排序
//   tab.variables.sort((a, b) => (a.var_sort || 0) - (b.var_sort || 0));
  
//   // 重新整理排序值，确保连续
//   let hasChanges = false;
//   for (let i = 0; i < tab.variables.length; i++) {
//     const expectedSort = i + 1;
//     if (tab.variables[i].var_sort !== expectedSort) {
//       tab.variables[i].var_sort = expectedSort;
//       hasChanges = true;
//     }
//   }
  
//   // 如果有变化，批量更新
//   if (hasChanges) {
//     const variablesToUpdate = tab.variables.map(v => ({
//       id: v.id,
//       var_sort: v.var_sort,
//       varName: v.name,
//       visible: v.visible !== undefined ? v.visible : 1,
//       var_group_name: v.var_group_name || v.name_group || '',
//       description: v.description || '',
//       mult: v.mult || 1,
//       minimum: v.minimum || 0,
//       maximum: v.maximum || 0,
//       var_default_value: v.value || v.var_default_value || 0
//     }));
    
//     await batchUpdateVariables(variablesToUpdate, tab);
//   }
  
//   // 刷新显示
//   await searchVariables();
// };


// 批量更新变量排序（优化版）
const batchUpdateVariables = async (variables, tab) => {
  try {
    if (!variables || variables.length === 0) {
      return { success: false, message: t('message.ClientProjectDeailAdd.noVariablesToBind') };
    }
    
    // 准备更新数据，只包含需要更新的字段
    const varInfos = variables.map(variable => ({
      id: variable.id,
      varName: variable.name,
      var_sort: variable.var_sort,
      visible: variable.visible !== undefined ? variable.visible : 1,
      var_group_name: variable.var_group_name || '',
      description: variable.description || '',
      mult: variable.mult || 1,
      minimum: variable.minimum || 0,
      maximum: variable.maximum || 0,
      var_default_value: variable.var_default_value || 0
    }));
    
    const bindData = {
      businessId: formData.business_id || props.businessId,
      projectId: projectId.value,
      companyId: formData.companyId,
      collectionsId: tab.id,
      domainId: tab.domainId,
      deviceId: variables[0].deviceId || tab.variables[0]?.deviceId,
      varInfos: varInfos
    };
    
    const response = await projectUpdateBindVar(bindData);
    
    if (response.success) {
      return {
        success: true,
        message: `${t('message.common.updateSuccess')} ${variables.length} ${t('message.ClientProjectDeailAdd.variables')}`,
        data: response.data
      };
    } else {
      return {
        success: false,
        message: response.msg || t('message.common.saveFailed')
      };
    }
  } catch (error) {
    console.error('批量更新变量失败:', error);
    return {
      success: false,
      message: error.message || t('message.ClientProjectDeailAdd.errorDuringBatchBinding')
    };
  }
};

// 上移
const moveUp = async (tabName, index) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab) return;
  
  if (index === 0) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.cannotMoveUp'));
    return;
  }
  
  try {
    const startIndex = (queryParams.pageNum - 1) * queryParams.pageSize;
    const actualIndex = startIndex + index;
    
    if (actualIndex <= 0) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.cannotMoveUp'));
      return;
    }
    
    // 交换两个变量的位置
    const temp = tab.variables[actualIndex];
    tab.variables[actualIndex] = tab.variables[actualIndex - 1];
    tab.variables[actualIndex - 1] = temp;
    
    // 更新排序值
    const variablesToUpdate = [];
    tab.variables[actualIndex].var_sort = actualIndex + 1;
    tab.variables[actualIndex - 1].var_sort = actualIndex;
    
    // 收集需要更新的变量
    const pageStartIndex = startIndex;
    const pageEndIndex = Math.min(startIndex + queryParams.pageSize, tab.variables.length);
    
    for (let i = pageStartIndex; i < pageEndIndex; i++) {
      if (tab.variables[i].var_sort !== i + 1) {
        tab.variables[i].var_sort = i + 1;
        variablesToUpdate.push(tab.variables[i]);
      }
    }
    
    if (variablesToUpdate.length === 0) {
      variablesToUpdate.push(tab.variables[actualIndex]);
      variablesToUpdate.push(tab.variables[actualIndex - 1]);
    }
    
    if (variablesToUpdate.length > 0) {
      const result = await batchUpdateVariables(variablesToUpdate, tab);
      if (result.success) {
        ElMessage.success(t('message.ClientProjectDeailAdd.moveUpSuccess'));
      } else {
        const tempRestore = tab.variables[actualIndex];
        tab.variables[actualIndex] = tab.variables[actualIndex - 1];
        tab.variables[actualIndex - 1] = tempRestore;
        ElMessage.error(result.message || t('message.ClientProjectDeailAdd.moveUpFailed'));
      }
    } else {
      ElMessage.success(t('message.ClientProjectDeailAdd.moveUpSuccess'));
    }
  } catch (error) {
    console.error('上移失败:', error);
    ElMessage.error(t('message.ClientProjectDeailAdd.moveUpFailed') + ': ' + error.message);
  }
};

// 下移
const moveDown = async (tabName, index) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab) return;
  
  const startIndex = (queryParams.pageNum - 1) * queryParams.pageSize;
  const actualIndex = startIndex + index;
  
  if (actualIndex >= tab.variables.length - 1) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.cannotMoveDown'));
    return;
  }
  
  try {
    const temp = tab.variables[actualIndex];
    tab.variables[actualIndex] = tab.variables[actualIndex + 1];
    tab.variables[actualIndex + 1] = temp;
    
    const variablesToUpdate = [];
    tab.variables[actualIndex].var_sort = actualIndex + 1;
    tab.variables[actualIndex + 1].var_sort = actualIndex + 2;
    
    const pageStartIndex = startIndex;
    const pageEndIndex = Math.min(startIndex + queryParams.pageSize, tab.variables.length);
    
    for (let i = pageStartIndex; i < pageEndIndex; i++) {
      if (tab.variables[i].var_sort !== i + 1) {
        tab.variables[i].var_sort = i + 1;
        variablesToUpdate.push(tab.variables[i]);
      }
    }
    
    if (variablesToUpdate.length === 0) {
      variablesToUpdate.push(tab.variables[actualIndex]);
      variablesToUpdate.push(tab.variables[actualIndex + 1]);
    }
    
    if (variablesToUpdate.length > 0) {
      const result = await batchUpdateVariables(variablesToUpdate, tab);
      if (result.success) {
        ElMessage.success(t('message.ClientProjectDeailAdd.moveDownSuccess'));
      } else {
        const tempRestore = tab.variables[actualIndex];
        tab.variables[actualIndex] = tab.variables[actualIndex + 1];
        tab.variables[actualIndex + 1] = tempRestore;
        ElMessage.error(result.message || t('message.ClientProjectDeailAdd.moveDownFailed'));
      }
    } else {
      ElMessage.success(t('message.ClientProjectDeailAdd.moveDownSuccess'));
    }
  } catch (error) {
    console.error('下移失败:', error);
    ElMessage.error(t('message.ClientProjectDeailAdd.moveDownFailed') + ': ' + error.message);
  }
};

/****************/
// ==================== 表格高度控制 ====================
// 计算表格可用高度
const calculateTableHeight = () => {
  // 获取窗口高度
  const windowHeight = window.innerHeight
  //const windowWidth = window.innerWidth
  
  // 根据不同屏幕尺寸设置不同的高度
  if (windowHeight < 700) {
    // 非常小的屏幕（如手机竖屏）
    tableHeight.value = '180px'
  } else if (windowHeight < 800) {
    // 小屏幕（如小尺寸笔记本）
    tableHeight.value = '220px'
  } else if (windowHeight < 900) {
    // 中等屏幕（大部分笔记本）
    tableHeight.value = '260px'
  } else if (windowHeight < 1080) {
    // 标准屏幕（大笔记本或小显示器）
    tableHeight.value = '300px'
  } else {
    // 大屏幕
    tableHeight.value = '350px'
  }
}

// 监听窗口大小变化
const handleResize = () => {
  calculateTableHeight()
}

// 设备变更事件
const handleDeviceChange = (device) => {
  
  updateTable([]);      
  updateTableSelection();
  clearAllSelection();
  if (device == null) return;
  handleDeviceIdChange(device.id);
}

const handleNodeClick = (nodeData) => {
  currentSelectedNode.value = nodeData;
}

// 加载从机方法
const loadSlave = async (deviceId) => {
  try {
    if (!deviceId) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.selectDeviceFirst'));
      return;
    }
    
    const res = await slavedetailbydevice({
      deviceId: deviceId,
      pageNum: 1,
      pageSize: 1000
    });
    
    queryVarGroupParams.deviceId = deviceId;
    
    if (res.success) {
      const fetchedSlaves = res.data.list || [];
      
      slaveOptions.value = [
        {
          value: -1,
          label: t('message.ClientProjectDeailAdd.allSlaves')
        },
        ...fetchedSlaves.map(slave => ({
          value: slave.slave_id,
          label: slave.slave_name || `Slave ${slave.slave_id}`
        }))
      ];
      
      if (slaveOptions.value.length > 0) {
        currentSlaveId.value = slaveOptions.value[0].value;
        queryVarGroupParams.slaveId = currentSlaveId.value > 0 ? currentSlaveId.value : undefined;
        await loadVariableGroups(queryVarGroupParams.deviceId, queryVarGroupParams.slaveId);
      }
    } else {
      ElMessage.error(res.msg || t('message.ClientProjectDeailAdd.loadSlavesFailed'));
    }
  } catch (error) {
    ElMessage.error(t('message.ClientProjectDeailAdd.loadSlavesFailed'));
  }
};

// 加载分组函数
const loadVariableGroups = async (deviceId, slaveId) => {
  try {
    if (!deviceId) return;
    
    const res = await vargroupdetailbydevice({
      deviceId: deviceId,
      slaveId: slaveId || undefined,
      pageNum: 1,
      pageSize: 1000
    });
    
    if (res.success) {
      VarGroupOptions.value = [
        { value: -1, label: t('message.ClientProjectDeailAdd.allGroups') },
        ...res.data.list.map(group => ({
          value: group.id,
          label: group.name_group
        }))
      ];

      if (VarGroupOptions.value.length > 0) {
        selectedGroupIds.value = [-1];
        selectedGroupNames.value = [t('message.ClientProjectDeailAdd.allGroups')];
      }
    }
  } catch (error) {
    console.error(t('message.ClientProjectDeailAdd.loadGroupsFailed'), error);
    ElMessage.error(t('message.ClientProjectDeailAdd.loadGroupsFailed'));
  }
};

// ID变化事件
const handleDeviceIdChange = async (selectedId) => {
  if (!selectedId) {
    currentDeviceId.value = null;
    currentSelectedNode.value = null;
    return;
  }
  
  if (currentSelectedNode.value && currentSelectedNode.value.type === 2) {
    const nodeData = currentSelectedNode.value;
    currentDeviceId.value = nodeData.id;
    await loadSlave(nodeData.id);
    
    const params = {
      companyId: nodeData.parentId,
      name: undefined,
      deviceCode: nodeData.deviceCode,
      pageNum: 1,
      pageSize: 10
    }

    const deviceDeails = await getDevices(params);
    if (deviceDeails.success && deviceDeails.data.list.length > 0) {
      currentDeviceInfo.value = {
        parentId: nodeData.parentId,
        name: nodeData.name,
        deviceCode: nodeData.deviceCode,
        organization: deviceDeails.data.list[0].company_name,
        template: deviceDeails.data.list[0].template_name,
        gateway: deviceDeails.data.list[0].gateway_name,
        address: deviceDeails.data.list[0].location,
        description: deviceDeails.data.list[0].description
      };
    } else {
      currentDeviceInfo.value = {
        parentId: nodeData.parentId,
        name: nodeData.name,
        deviceCode: nodeData.deviceCode,
        organization: '',
        template: '',
        gateway: '',
        address: '',
        description: '0'
      };
    }
  } else {
    currentDeviceId.value = null;
    currentDeviceInfo.value = {
      parentId: 0,
      name: '',
      deviceCode: '',
      organization: '',
      template: '',
      gateway: '',
      address: '',
      description: ''
    };
  }
};

// 从机变化处理
const handleSlaveChange = () => {
  queryVarGroupParams.slaveId = currentSlaveId.value > 0 ? currentSlaveId.value : undefined;
  loadVariableGroups(queryVarGroupParams.deviceId, queryVarGroupParams.slaveId);
};

// 分组变化处理
const handleGroupChange = () => {
  // 处理分组选择逻辑
};

// 变量名称输入处理
const handleNameInput = () => {
  // 处理变量名称输入
};

// 初始化业务块Tabs
const initializeSlaveTabs = () => {
  if (props.slaveTabsData?.length > 0) {
    slaveTabs.value = JSON.parse(JSON.stringify(props.slaveTabsData));
    activeTab.value = slaveTabs.value[0]?.name ?? props.businessName;
  } else {
    slaveTabs.value = [{
      id: 0,
      name: props.businessName,
      label: props.businessName,
      domainId: 2,
      variables: [],
      selectedVariables: []
    }];
    activeTab.value = props.businessName;
  }
  
  queryParams.name = '';
  queryParams.display_name = '';
  queryParams.pageNum = 1;
  queryParams.pageSize = 500;
  queryParams.total = 0;
  
  // 重置项目ID和集合ID
  projectId.value = 0
  projectCollectionsId.value = 0
}

// 渲染Tab标签
const renderTabLabel = (tab) => {
  if (!tab) {
    return t('message.ClientProjectDeailAdd.parameterModule');
  }
  const label = tab.label || t('message.ClientProjectDeailAdd.parameterModule');
  return `${label}`;
}

// 新增项目保存函数
const saveProject = async () => {
  try {
    if (!formData.name) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.fillProjectName'));
      return { success: false };
    }
    
    const projectData = {
      businessId: formData.business_id || props.businessId,
      companyId: formData.companyId,
      name: formData.name,
      location: formData.location || '',
      description: formData.description || ''
    };
    
    let response;
    if (projectId.value) {
      projectData.id = projectId.value;
      response = await projectUpdate(projectData);
    } else {
      response = await projectAdd(projectData);
    }
    
    if (response.success && response.data) {
      projectId.value = response.data.id || response.data.projectId || projectId.value;
      
      if (!projectData.id) {
        ElMessage.success(t('message.ClientProjectDeailAdd.projectSavedSuccess'));
      } else {
        ElMessage.success(t('message.ClientProjectDeailAdd.projectUpdatedSuccess'));
      }
      
      return { success: true, id: projectId.value };
    } else {
      ElMessage.error(response.msg || t('message.ClientProjectDeailAdd.projectSaveFailed'));
      return { success: false };
    }
  } catch (error) {
    ElMessage.error(t('message.ClientProjectDeailAdd.errorSavingProject') + ': ' + error.message);
    return { success: false };
  }
};

// 新增集合保存函数
const saveProjectCollection = async (tab) => {
  try {
    if (!tab.label) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.fillModuleName'));
      return { success: false };
    }
    
    const projectResult = await saveProject();
    if (!projectResult.success) {
      return { success: false };
    }
    
    const collectionData = {
      projectId: projectId.value,
      companyId: formData.companyId,
      name: tab.label
    };
    
    let response;
    
    if (tab.id && tab.id > 0) {
      collectionData.id = tab.id;
      collectionData.domainId = tab.domainId;
      
      response = await projectCollectionsUpdate(collectionData);
      
      if (response.success) {
        console.log(t('message.ClientProjectDeailAdd.parameterModuleUpdatedSuccess'));
        return { success: true, id: tab.id };
      } else {
        ElMessage.error(response.msg || t('message.ClientProjectDeailAdd.moduleUpdateFailed'));
        return { success: false };
      }
    } else {
      response = await projectCollectionsAdd(collectionData);
      
      if (response.success && response.data) {
        const collectionId = response.data.id;
        
        tab.id = collectionId;
        projectCollectionsId.value = collectionId;
        
        ElMessage.success(t('message.ClientProjectDeailAdd.parameterModuleSavedSuccess'));
        return { success: true, id: collectionId };
      } else {
        ElMessage.error(response.msg || t('message.ClientProjectDeailAdd.moduleSaveFailed'));
        return { success: false };
      }
    }
  } catch (error) {
    ElMessage.error(t('message.ClientProjectDeailAdd.errorSavingModule') + ': ' + error.message);
    return { success: false };
  }
};

// 添加Tab
const addTab = async (targetName, action) => {
  if (!formData.name) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.fillProjectName'));
    return { success: false };
  }

  if (action === "add") {
    const lastTab = slaveTabs.value[slaveTabs.value.length - 1];
    
    if (!lastTab.label || !lastTab.domainId) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.completeCurrentModule'));
      return;
    }
    
    try {
      if (!projectId.value) {
        const projectResult = await saveProject();
        if (!projectResult.success) {
          return;
        }
      }

      if (!lastTab.id) {
        const result = await saveProjectCollection(lastTab);
        if (!result.success) {
          ElMessage.error(t('message.ClientProjectDeailAdd.moduleSaveFailed'));
          return;
        }
        ElMessage.success(t('message.ClientProjectDeailAdd.currentModuleSaved'));
      }
      
      const tabIndex = slaveTabs.value.length + 1;
      const newTab = {
        id: 0,
        name: `${props.businessName}${tabIndex}`,
        label: `${props.businessName}${tabIndex}`,
        domainId: 2,
        variables: [],
        selectedVariables: []
      };
      slaveTabs.value.push(newTab);
      activeTab.value = newTab.name;
      
      ElMessage.success(t('message.ClientProjectDeailAdd.parameterModuleAddedSuccess'));
    } catch (error) {
      ElMessage.error(t('message.ClientProjectDeailAdd.addFailed') + ': ' + error.message);
    }
  }
}

// 删除Tab
const removeTab = async (targetName) => {
  if (slaveTabs.value.length <= 1) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.keepAtLeastOneModule'));
    return;
  }

  try {
    await ElMessageBox.confirm(
      t('message.ClientProjectDeailAdd.confirmDeleteModule'),
      t('message.ClientProjectDeailAdd.prompt'),
      {
        confirmButtonText: t('message.ClientProjectDeailAdd.confirm'),
        cancelButtonText: t('message.ClientProjectDeailAdd.cancel'),
        type: 'warning'
      }
    ); 
    const tabToRemove = slaveTabs.value.find(tab => tab.name === targetName)
    
    console.log("removeTab",tabToRemove)
    if (tabToRemove.id>0) {        
        const collectionData = {
          projectId: projectId.value,
          companyId: formData.companyId,
          name: tabToRemove.label
        };
      
        let response;
        collectionData.id = tabToRemove.id;
        collectionData.domainId = tabToRemove.domainId;
        
        response = await projectCollectionsDelete(collectionData);
        
        if (!response.success) {          
          ElMessage.error(response.msg || t('message.ClientProjectDeailAdd.moduleDeleteFailed'));
          return;
        }
      
    } 
            // 先确定新的activeTab
    let newActiveTab = activeTab.value
    if (activeTab.value === targetName) {
      const currentIndex = slaveTabs.value.findIndex(tab => tab.name === targetName)
      // 优先选择后一个tab，如果不存在则选择前一个
      newActiveTab = slaveTabs.value[currentIndex + 1]?.name || 
                    slaveTabs.value[currentIndex - 1]?.name
    }

    // 执行删除
    slaveTabs.value = slaveTabs.value.filter(tab => tab.name !== targetName)
    
    // 更新activeTab
    if (activeTab.value === targetName) {
      activeTab.value = newActiveTab
    }
 
  } catch {
    // 用户取消删除
  }
}

// 添加变量
const addVariable = async (tabName) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab) return;
  
  try {
    if (!tab.id) {
      const result = await saveProjectCollection(tab);
      if (!result.success) {
        return;
      }
    }
    
    resetCurrentVariable();
    variableDialogTitle.value = t('message.ClientProjectDeailAdd.addVariable');
    
    tablePagination.total =0;
    variableDialogVisible.value = true;
  } catch (error) {
    ElMessage.error(t('message.ClientProjectDeailAdd.addFailed') + ': ' + error);
  }
}

// 编辑变量
const editVariable = (tabName, index) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab) return;
  
  currentVariable.value = { ...tab.variables[index] };
  variableEditDialogTitle.value = t('message.ClientProjectDeailAdd.editVariable');
  variableEditDialogVisible.value = true;
}

// 保存变量
const saveVariable = async () => {
  try {
    const tab = slaveTabs.value.find(t => t.name === activeTab.value);
    if (!tab) return;
    
    if (!currentVariable.value.name) {
      ElMessage.error(t('message.ClientProjectDeailAdd.enterVariableName'));
      return;
    }
    
    if (!tab.id) {
      const result = await saveProjectCollection(tab);
      if (!result.success) {
        return;
      }
    }
    
    if (currentVariable.value.id) {
      const index = tab.variables.findIndex(v => v.id === currentVariable.value.id);
      if (index !== -1) {
        currentVariable.value.collectionId = tab.id;
        currentVariable.value.projectId = projectId.value;
        tab.variables[index] = { ...currentVariable.value };
      }
    } else {
      currentVariable.value.id = generateId();
      currentVariable.value.collectionId = tab.id;
      currentVariable.value.projectId = projectId.value;
      tab.variables.push({ ...currentVariable.value });
    }
    
    variableEditDialogVisible.value = false;
    ElMessage.success(t('message.ClientProjectDeailAdd.savedSuccess'));
  } catch (error) {
    ElMessage.error(t('message.ClientProjectDeailAdd.saveFailed') + ': ' + error.message);
  }
}

const connectionVariable = async (tabName, index) => {
  console.log("connectionVariable",tabName, index);
  const tab = slaveTabs.value.find(t => t.name === tabName);
  const variableToDelete = tab.variables[index];
  linkageTabCurrentVerIndex.value = index;
  currentLinkage.value.linkageVars = tab.variables[index].linkageVars;
  currentLinkage.value.project_info_bind_id = variableToDelete.id;
  openLinkageDialog();
}

// 删除变量 - 添加后端删除调用
const deleteVariable = async (tabName, index) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab) return;
  
  try {
    await ElMessageBox.confirm(
      t('message.ClientProjectDeailAdd.confirmDeleteVariable'),
      t('message.ClientProjectDeailAdd.prompt'),
      {
        confirmButtonText: t('message.ClientProjectDeailAdd.confirm'),
        cancelButtonText: t('message.ClientProjectDeailAdd.cancel'),
        type: 'warning'
      }
    );

    // 获取要删除的变量
    const variableToDelete = tab.variables[index];
    
    // 如果有绑定ID，调用后端删除接口
    if (variableToDelete.id) {
      try {
        const deleteData = {
          businessId: formData.business_id || props.businessId,
          projectId: variableToDelete.projectId,
          companyId: formData.companyId,
          collectionsId: variableToDelete.collectionId,
          domainId: variableToDelete.domainId,
          deviceId: variableToDelete.deviceId,
          varInfos: [{
            varName: variableToDelete.name,
            mult: variableToDelete.mult || 1,
            minimum: variableToDelete.minimum || 0,
            maximum: variableToDelete.maximum || 0,
            var_default_value: variableToDelete.value || 0,
            description: variableToDelete.description || '',
            var_group_name: variableToDelete.varGroupName || variableToDelete.name_group || '',
            var_sort: variableToDelete.var_sort || 1,
            visible: 1
          }]
        };
        
        const deleteResult = await DeleteProjectBindVarAsync(deleteData);
        
        if (deleteResult.success) {
          // 从前端列表删除
          tab.variables.splice(index, 1);
          ElMessage.success(t('message.ClientProjectDeailAdd.variableDeletedSuccess'));
          searchVariables();
        } else {
          ElMessage.error(deleteResult.msg || t('message.ClientProjectDeailAdd.deleteFailed'));
          return;
        }
      } catch (error) {
        console.error(t('message.ClientProjectDeailAdd.deleteApiFailed'), error);
        ElMessage.error(t('message.ClientProjectDeailAdd.errorDuringDeletion'));
        return;
      }
    } else {
      // 如果没有绑定ID，只从前端删除
      tab.variables.splice(index, 1);
      ElMessage.success(t('message.ClientProjectDeailAdd.deletedSuccess'));
    }
  } catch {
    // 用户取消删除
  }
}

// 批量删除变量 - 添加后端删除调用
const batchDeleteVariables = async (tabName) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab || !tab.selectedVariables.length) return;

  try {
    await ElMessageBox.confirm(
      `${t('message.ClientProjectDeailAdd.confirmDeleteSelected')} ${tab.selectedVariables.length} ${t('message.ClientProjectDeailAdd.confirmDeleteVariables')}`,
      t('message.ClientProjectDeailAdd.prompt'),
      {
        confirmButtonText: t('message.ClientProjectDeailAdd.confirm'),
        cancelButtonText: t('message.ClientProjectDeailAdd.cancel'),
        type: 'warning'
      }
    );

    const selectedVariables = tab.selectedVariables;
    const hasBindIds = selectedVariables.some(v => v.id);
    
    if (hasBindIds) {
      // 按 deviceId 分组变量
      const groupedByDevice = {};
      selectedVariables.forEach(variable => {
        const deviceId = variable.deviceId;
        if (!groupedByDevice[deviceId]) {
          groupedByDevice[deviceId] = [];
        }
        groupedByDevice[deviceId].push(variable);
      });
      
      const deviceKeys = Object.keys(groupedByDevice);
      
      // 如果所有变量都是同一个 deviceId，一次性删除
      if (deviceKeys.length === 1) {
        const deviceId = deviceKeys[0];
        const deleteData = {
          businessId: formData.business_id || props.businessId,
          projectId: projectId.value,
          companyId: formData.companyId,
          collectionsId: tab.id,
          domainId: tab.domainId,
          deviceId: deviceId,
          varInfos: selectedVariables.map(variable => ({
            varName: variable.name,
            mult: variable.mult || 1,
            minimum: variable.minimum || 0,
            maximum: variable.maximum || 0,
            var_default_value: variable.value || 0,
            description: variable.description || '',
            var_group_name: variable.varGroupName || variable.name_group || '',
            var_sort: variable.var_sort || 1,
            visible: 1
          }))
        };
        
        const deleteResult = await DeleteProjectBindVarAsync(deleteData);
        
        if (deleteResult.success) {
          const selectedIds = selectedVariables.map(v => v.id);
          tab.variables = tab.variables.filter(
            variable => !selectedIds.includes(variable.id)
          );
          tab.selectedVariables = [];
          ElMessage.success(`${t('message.ClientProjectDeailAdd.successfullyDeleted')} ${selectedVariables.length} ${t('message.ClientProjectDeailAdd.variables')}`);
          searchVariables();
        } else {
          ElMessage.error(deleteResult.msg || t('message.ClientProjectDeailAdd.batchDeleteFailed'));
        }
      } else {
        // 如果有多个不同的 deviceId，分多次删除
        let totalDeleted = 0;
        let failedDevices = [];
        
        for (const [deviceId, variables] of Object.entries(groupedByDevice)) {
          try {
            const deleteData = {
              businessId: formData.business_id || props.businessId,
              projectId: projectId.value,
              companyId: formData.companyId,
              collectionsId: tab.id,
              domainId: tab.domainId,
              deviceId: deviceId,
              varInfos: variables.map(variable => ({
                varName: variable.name,
                mult: variable.mult || 1,
                minimum: variable.minimum || 0,
                maximum: variable.maximum || 0,
                var_default_value: variable.value || 0,
                description: variable.description || '',
                var_group_name: variable.varGroupName || variable.name_group || '',
                var_sort: variable.var_sort || 1,
                visible: 1
              }))
            };
            
            const deleteResult = await DeleteProjectBindVarAsync(deleteData);
            
            if (deleteResult.success) {
              totalDeleted += variables.length;
              // 立即从当前选中的变量中移除已成功删除的
              const deletedIds = variables.map(v => v.id);
              tab.selectedVariables = tab.selectedVariables.filter(
                v => !deletedIds.includes(v.id)
              );      
            } else {
              failedDevices.push({
                deviceId,
                count: variables.length,
                message: deleteResult.msg || t('message.ClientProjectDeailAdd.deleteFailed')
              });
            }
          } catch (error) {
            console.error(`${t('message.ClientProjectDeailAdd.device')} ${deviceId} ${t('message.ClientProjectDeailAdd.deleteFailed')}:`, error);
            failedDevices.push({
              deviceId,
              count: variables.length,
              message: t('message.ClientProjectDeailAdd.apiCallException')
            });
          }
        }
        
        // 从前端列表中删除所有成功删除的变量
        if (totalDeleted > 0) {
          // 获取已删除的变量ID（从选中的变量中已经移除了成功的）
          const deletedIds = selectedVariables
            .filter(v => !tab.selectedVariables.find(sv => sv.id === v.id))
            .map(v => v.id);
          
          tab.variables = tab.variables.filter(
            variable => !deletedIds.includes(variable.id)
          );
          
          if (failedDevices.length === 0) {
            ElMessage.success(`${t('message.ClientProjectDeailAdd.successfullyDeleted')} ${totalDeleted} ${t('message.ClientProjectDeailAdd.variables')}`);
            searchVariables();
          } else {
            ElMessage.success(`${t('message.ClientProjectDeailAdd.deleted')} ${totalDeleted} ${t('message.ClientProjectDeailAdd.variables')}，${failedDevices.length} ${t('message.ClientProjectDeailAdd.deviceVariablesFailed')}`);
            failedDevices.forEach(failed => {
              console.warn(`${t('message.ClientProjectDeailAdd.device')} ${failed.deviceId} ${t('message.ClientProjectDeailAdd.variableDeletionFailed')}: ${failed.message}`);
            });
          }
        } else {
          ElMessage.error(t('message.ClientProjectDeailAdd.allDeletionsFailed'));
        }
        
        // 清空选中的变量列表
        tab.selectedVariables = [];
      }
    } else {
      // 如果没有绑定ID，只从前端删除
      const selectedIds = selectedVariables.map(v => v.id);
      tab.variables = tab.variables.filter(
        variable => !selectedIds.includes(variable.id)
      );
      tab.selectedVariables = [];
      ElMessage.success(t('message.ClientProjectDeailAdd.deletedSuccess'));            
    }
  } catch (error) {
    console.error(t('message.ClientProjectDeailAdd.batchDeleteFailed'), error);
    if (error !== 'cancel') {
      ElMessage.error(t('message.ClientProjectDeailAdd.errorDuringDeletion'));
    }
  }
}

// 处理选择变化
const handleSelectionChange = (tabName, selection) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (tab) {
    tab.selectedVariables = selection;
  }
}


// 在 script 部分添加 handleDomainChange 方法
const handleDomainChange = async (tabName) => {
    const tab = slaveTabs.value.find(t => t.name === tabName);
    if (!tab) return;  
    console.log(`参数选项变化: ${tab.name}, domainId: ${tab.domainId}`);
    
    // 如果已经有项目ID和集合ID，直接执行查询
    if (tab.id && projectId.value) {
      await searchVariables();
    }
};

// 搜索变量
const searchVariables = async () => {
  const tab = slaveTabs.value.find(t => t.name === activeTab.value);
  if (!tab) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.selectModuleFirst'));
    return;
  }
  
  if (!tab.id) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.saveModuleFirst'));
    return;
  }
  
  if (!projectId.value) {
    ElMessage.warning(t('message.ClientProjectDeailAdd.saveProjectFirst'));
    return;
  }
  
  try {
    isLoading.value = true;
    
    const params = {
      projectId: projectId.value,
      businessId: formData.business_id || props.businessId,
      collectionsId: tab.id,
      domainParentId: 0,
      domainId: tab.domainId,
      companyId: formData.companyId,
      groupNames: undefined,
      names:  undefined,
      name: queryParams.name ?? undefined,
      display_name: queryParams.display_name || undefined,
      deviceCodeNames: undefined,
      pageNum: queryParams.pageNum,
      pageSize: queryParams.pageSize === 0 ? 100000 : queryParams.pageSize,
    };
    
    const res = await projectCollectionsDomainVars(params);
    
    if (!res.success) {
      ElMessage.error(res?.msg);
      return;
    }
    
    if (!res.data.list || res.data.list.length === 0) {
      tab.variables = [];
      queryParams.total = 0;
      ElMessage.warning(t('message.ClientProjectDeailAdd.noMatchingVariables'));
      return;
    }
    
    const transformedVariables = convertToVariableData(res);
    
    tab.variables = transformedVariables;
    queryParams.total = res.data.totalCount || transformedVariables.length;
    
    ElMessage.success(`${t('message.ClientProjectDeailAdd.querySuccessfulFound')} ${transformedVariables.length} ${t('message.ClientProjectDeailAdd.variables')}`);
    
  } catch (error) {
    console.error(t('message.ClientProjectDeailAdd.queryVariablesFailed'), error);
    ElMessage.error(error.message || t('message.ClientProjectDeailAdd.queryFailed'));
  } finally {
    isLoading.value = false;
  }
};

// 转换数据格式的函数
const convertToVariableData = (res) => {
  if (!res?.data?.list) {
    return [];
  }
  
  const variables = [];
  const tab = slaveTabs.value.find(t => t.name === activeTab.value);
  
  res.data.list.forEach(group => {
    if (group.list_parm && Array.isArray(group.list_parm)) {
      group.list_parm.forEach(param => {
        if (param.display_name === t('message.ClientProjectDeailAdd.unknownParameter')) {
          return;
        } 
        
        const variable = {
          id: param.id,
          domainId: group.domainId || tab.domainId,
          var_id: param.var_id,
          name: param.var_name || '',
          display_name: param.display_name || param.var_name || '',
          unit: param.var_unit || '',
          value: param.default_value || 0,
          mult: param.mult || 1,
          minimum: param.minimum,
          maximum: param.maximum,
          var_decimal: param.var_decimal,
          description: param.description || '',
          var_group_name: group.group_name || '',
          var_sort: param.var_sort || 1,
          deviceCode: param.device_code || '',
          deviceName: param.device_name || '',
          updateAt: param.update_at ? param.update_at.replace('T', ' ') : '',
          var_default_value: param.default_value,
          varCmdSwitch: Number(param.var_cmd_switch) || 0,
          deviceId: param.deviceId,
          collectionId: group.collectionsId || activeTab.value.id || 0,
          projectId: group.project_id || projectId.value,
          linkageVars: param.projectInfoBindLinkages || [],
        };
        
        variables.push(variable);
      });
    }
  });
  
  return variables;
};

// Tab切换处理
const handleTabChange = (activeName) => {
  const tab = slaveTabs.value.find(t => t.name === activeName);
  if (!tab) return;
  
  queryParams.pageNum = 1;
  queryParams.pageSize = 500;
  
  if (tab.id) {
    searchVariables();
  }
};

//保存更新数据
const handleUpdateProject = async (tabName) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab) return; 
 
  try {
    const result = await saveProjectCollection(tab);
    if (!result.success) {
      return;
    }
  } catch (error) {
    ElMessage.error(t('message.ClientProjectDeailAdd.addFailed') + ': ' + error);
  } 
};

const displayedVariables = computed(() => {
  const tab = slaveTabs.value.find(t => t.name === activeTab.value);
  if (!tab) return [];

  // 👇 这里加了按 var_sort 排序
  const sortedList = [...tab.variables].sort((a, b) => {
    return a.var_sort - b.var_sort;
  });

  const start = (queryParams.pageNum - 1) * queryParams.pageSize;
  const end = start + queryParams.pageSize;

  // 👇 用排序后的数组进行分页
  return sortedList.slice(start, end);
});

// // 在变量表格的script部分添加计算属性来显示数据
// const displayedVariables = computed(() => {
//   const tab = slaveTabs.value.find(t => t.name === activeTab.value);
//   if (!tab) return [];
  
//   const start = (queryParams.pageNum - 1) * queryParams.pageSize;
//   const end = start + queryParams.pageSize;
//   return tab.variables.slice(start, end);
// });

// 导入变量
const importVariables = async (tabName) => {
  const tab = slaveTabs.value.find(t => t.name === tabName);
  if (!tab) return;
  
  try {
    if (!tab.id) {
      const result = await saveProjectCollection(tab);
      if (!result.success) {
        return;
      }
    }
    
    variableDialogTitle.value = t('message.ClientProjectDeailAdd.importVariables');
    variableDialogVisible.value = true;
  } catch (error) {
    ElMessage.error(t('message.ClientProjectDeailAdd.importFailed') + ': ' + error);
  }
}

// 导出变量
const handleExport = (tabName) => {
  ElMessage.error(`${tabName} ${t('message.ClientProjectDeailAdd.exportNotImplemented')}`);
}

// 重置当前变量
const resetCurrentVariable = () => {
  currentVariable.value = {
    id: 0,
    name: '',
    display_name: '',
    unit: '',
    value: 0,
    mult: 1,
    minimum: 0,
    maximum: 0,
  }
}

// 分页大小变化
const handleSizeChange = (val) => {
  queryParams.pageSize = val;
  searchVariables();
}

// 当前页变化
const handleCurrentChange = (val) => {
  queryParams.pageNum = val;
  searchVariables();
}

// ==================== 对话框相关方法 ====================

// 对话框关闭处理
const handleDialogClosed = () => {
  searchForm.deviceId = null;
  selectedVariables.value = [];
  tableSearchText.value = '';
  tableSelectedVariables.value = [];
  tablePagination.currentPage = 1;
  filteredVariables.value = [];
  
  if (variableTableRef.value) {
    variableTableRef.value.clearSelection();
  }
}

// 处理行选择事件
const handleRowSelect = (selection, row) => {
  if (selection.includes(row)) {
    if (!selectedVariables.value.some(v => v.var_id === row.var_id)) {
      selectedVariables.value.push(row);
    }
  } else {
    const index = selectedVariables.value.findIndex(v => v.var_id === row.var_id);
    if (index !== -1) {
      selectedVariables.value.splice(index, 1);
    }
  }
  
  updateTableSelection();
}

// 处理全选/取消全选事件
const handleSelectAll = (selection) => {
  if (selection.length === 0) {
    filteredVariables.value.forEach(row => {
      const index = selectedVariables.value.findIndex(v => v.var_id === row.var_id);
      if (index !== -1) {
        selectedVariables.value.splice(index, 1);
      }
    });
  } else {
    filteredVariables.value.forEach(row => {
      if (!selectedVariables.value.some(v => v.var_id === row.var_id)) {
        selectedVariables.value.push(row);
      }
    });
  }
  
  updateTableSelection();
}

// 更新表格选中状态
const updateTableSelection = () => {
  if (variableTableRef.value) {
    variableTableRef.value.clearSelection();
    
    nextTick(() => {
      filteredVariables.value.forEach(row => {
        if (selectedVariables.value.some(v => v.var_id === row.var_id)) {
          variableTableRef.value.toggleRowSelection(row, true);
        }
      });
    });
  }
}

// 表格选择变化事件
const handleTableSelectionChange = (selection) => {
  tableSelectedVariables.value = selection;
}

// 切换变量选择状态
const toggleVariableSelection = (variable) => {
  if (isVariableSelected(variable)) {
    const index = selectedVariables.value.findIndex(v => v.var_id === variable.var_id);
    if (index !== -1) {
      selectedVariables.value.splice(index, 1);
      ElMessage.info(`${t('message.ClientProjectDeailAdd.removedVariable')}:${variable.display_name || variable.varName}`);
    }
  } else {
    if (!selectedVariables.value.some(v => v.var_id === variable.var_id)) {
      selectedVariables.value.push(variable);
      ElMessage.success(`${t('message.ClientProjectDeailAdd.addedVariable')}:${variable.display_name || variable.varName}`);
    }
  }
  
  updateTableSelection();
}

// 检查变量是否已选择
const isVariableSelected = (variable) => {
  return selectedVariables.value.some(v => v.var_id === variable.var_id);
}

// 添加到项目按钮点击
// const addSelectedToProject = () => {
//   tableSelectedVariables.value.forEach(variable => {
//     if (!selectedVariables.value.some(v => v.var_id === variable.var_id)) {
//       selectedVariables.value.push(variable);
//     }
//   });
  
//   updateTableSelection();
//   ElMessage.success(`已添加 ${tableSelectedVariables.value.length} 个变量到选择列表`);
// }

// 清空所有选择
const clearAllSelection = () => {
  selectedVariables.value = [];
  tableSelectedVariables.value = [];
  
  if (variableTableRef.value) {
    variableTableRef.value.clearSelection();
  }
}

// // 表格搜索过滤
// const filterTableData = () => {
//   if (!tableSearchText.value) {
//     updateTableSelection();
//     return;
//   }
  
//   const search = tableSearchText.value.toLowerCase();
//   filteredVariables.value = filteredVariables.value.filter(variable => 
//     (variable.varName && variable.varName.toLowerCase().includes(search)) ||
//     (variable.display_name && variable.display_name.toLowerCase().includes(search)) ||
//     (variable.description && variable.description.toLowerCase().includes(search))
//   );
  
//   updateTableSelection();
// }

// 获取行键值
const getRowKey = (row) => {
  return row.var_id || row.varName || Math.random();
}

// 查询变量 - 使用新的 projectDeviceVarsList 接口
const handleQuery = async () => {
  try {
    const tab = slaveTabs.value.find(t => t.name === activeTab.value);
    if (!tab) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.selectModuleFirst'));
      return;
    }
    
    if (!tab.id) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.saveModuleFirst'));
      return;
    }
    
    if (!projectId.value) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.saveProjectFirst'));
      return;
    }

    let nameGroups = undefined;
    if (selectedGroupIds.value.length > 0) {
      const validGroupIds = selectedGroupIds.value.filter(id => id !== -1);
      if (validGroupIds.length > 0) {
        nameGroups = validGroupIds.map(groupId => {
          const group = VarGroupOptions.value.find(g => g.value === groupId);
          return group ? group.label : null;
        }).filter(name => name);
      }
    }

    if (!currentDeviceInfo.value.deviceCode) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.selectDeviceFirst'));
      return;
    }
    
    const params = {
      company_id: currentDeviceInfo.value.parentId,
      device_code: currentDeviceInfo.value.deviceCode,
      name_group: nameGroups && nameGroups.length > 0 ? nameGroups : undefined,
      slave_id: currentSlaveId.value > 0 ? currentSlaveId.value : undefined,
      names: currentVarName.value || undefined,
      businessId: formData.business_id || props.businessId,
      projectId: projectId.value,      
      collectionsId: tab.id,
      domainId: tab.domainId,
      deviceId: currentDeviceId.value,
      pageNum: tablePagination.currentPage,
      pageSize: tablePagination.pageSize
    };
    
    const response = await projectDeviceVarsList(params);
    
    if (response.success) {
      tablePagination.total = response.data.totalCount || 0;
      updateTable(response.data.list || []);
      
      updateTableSelection();
      ElMessage.success(`${t('message.ClientProjectDeailAdd.querySuccessfulFound')} ${response.data.list?.length || 0} ${t('message.ClientProjectDeailAdd.variables')}`);
    } else {
      ElMessage.error(response?.msg || t('message.ClientProjectDeailAdd.queryFailed'));
    }
  } catch (error) {
    console.error(t('message.ClientProjectDeailAdd.queryVariablesFailed'), error);
    ElMessage.error(t('message.ClientProjectDeailAdd.queryFailed') + ': ' + error.message);
  }
};

// 更新表格数据 - 适配新的数据结构
const updateTable = (data) => {
  const transformedData = data.map(item => ({
    var_id: item.var_id,
    deviceCode: item.device_code || t('message.ClientProjectDeailAdd.placeholder'),
    deviceName: item.device_name || t('message.ClientProjectDeailAdd.placeholder'),
    varName: item.var_name || t('message.ClientProjectDeailAdd.placeholder'),
    display_name: item.display_name || item.var_name || t('message.ClientProjectDeailAdd.placeholder'),
    name_group: item.name_group || t('message.ClientProjectDeailAdd.placeholder'),
    description: item.description || t('message.ClientProjectDeailAdd.placeholder'),
    slaveName: item.slave_name || t('message.ClientProjectDeailAdd.placeholder'),
    varType: item.var_type || t('message.ClientProjectDeailAdd.placeholder'),
    rw_type: item.rw_type || t('message.ClientProjectDeailAdd.placeholder'),
    rw_type_id: item.rw_type_id,
    mult: item.mult || 1,
    minimum: item.minimum,
    maximum: item.maximum,
    var_decimal: item.var_decimal,
    default_value: item.default_value,
    unit: item.unit || '',
    gateway_imei: item.gateway_imei || t('message.ClientProjectDeailAdd.placeholder')
  }));
  
  filteredVariables.value = transformedData;
};

// 查看变量详情
const viewVariableDetail = (variable) => {
    const formatNumber = (num, decimalPlaces) => {
    // 如果小数位数未定义或不是数字，默认保留0位
    const places = typeof decimalPlaces === 'number' && !isNaN(decimalPlaces) ? decimalPlaces : 0;
    // 确保num是数字类型
    const number = Number(num);
    // 如果转换失败，返回原始值
    if (isNaN(number)) return num;
    // 保留指定小数位数
    return number.toFixed(places);
  };

  ElMessageBox.alert(`
    <div style="max-height: 300px; overflow-y: auto;">
      <p><strong>${t('message.ClientProjectDeailAdd.variableName')}:</strong>${variable.varName}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.displayName')}:</strong>${variable.display_name || t('message.ClientProjectDeailAdd.none')}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.belongingDevice')}:</strong>${variable.deviceName || t('message.ClientProjectDeailAdd.none')}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.variableGroup')}:</strong>${variable.name_group || t('message.ClientProjectDeailAdd.ungrouped')}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.variableType')}:</strong>${variable.varType || t('message.ClientProjectDeailAdd.placeholder')}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.readWriteType')}:</strong>${variable.rw_type || t('message.ClientProjectDeailAdd.placeholder')}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.defaultValue')}:</strong>${formatNumber(variable.default_value, variable.var_decimal)} ${variable.unit ?? ''}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.coefficient')}:</strong>${formatNumber(variable.mult || 1, variable.var_decimal)}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.valueRange')}:</strong>${variable.minimum ?? 0} ~ ${variable.maximum ?? 0}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.decimalPlaces')}:</strong>${variable.var_decimal}</p>
      <p><strong>${t('message.ClientProjectDeailAdd.description')}:</strong>${variable.description || t('message.ClientProjectDeailAdd.none')}</p>
    </div>
  `, t('message.ClientProjectDeailAdd.variableDetails'), {
    dangerouslyUseHTMLString: true,
    customClass: 'variable-detail-dialog',
    showConfirmButton: false,
    showCancelButton: true,
    cancelButtonText: t('message.ClientProjectDeailAdd.close')
  })
}

// 表格分页变化
const handleTableSizeChange = (size) => {
  tablePagination.pageSize = size;
  tablePagination.currentPage = 1;
  handleQuery();
}

const handleTablePageChange = (page) => {
  tablePagination.currentPage = page;
  handleQuery();
}

//退出
const cancelSelection = async () => {
 
    updateTable([]);      
    updateTableSelection();
    clearAllSelection();
    variableDialogVisible.value = false
    return;
}
// 确定选择 - 将选择的变量添加到项目并批量绑定
const confirmSelection = async () => {
  const tab = slaveTabs.value.find(t => t.name === activeTab.value);
  if (tab && selectedVariables.value.length > 0) {
    
    if (!tab.id) {
      const result = await saveProjectCollection(tab);
      if (!result.success) {
        return;
      }
    }
    
    if (!projectId.value) {
      const projectResult = await saveProject();
      if (!projectResult.success) {
        return;
      }
    }
    
    const variablesToBind = [];
    const alreadyExistsVariables = [];
    
    for (const variable of selectedVariables.value) {
      try {
        const projectVariable = {
          id: generateId(),
          collectionId: tab.id,
          projectId: projectId.value,
          domainId: tab.domainId,
          name: variable.varName,
          display_name: variable.display_name || variable.varName,
          unit: variable.unit || '',
          value: variable.default_value || 0,
          mult: variable.mult || 1,
          minimum: variable.minimum,
          maximum: variable.maximum,
          dataType: variable.varType,
          deviceName: variable.deviceName,
          description: variable.description,
          deviceId: currentDeviceId.value,
          varId: variable.var_id,
          varGroupName: variable.name_group || ''
        };
        
        const existingVarIndex = tab.variables.findIndex(v => v.name === projectVariable.name);
        
        if (existingVarIndex === -1) {
          variablesToBind.push(variable);
        } else {
          tab.variables[existingVarIndex] = { ...projectVariable };
          alreadyExistsVariables.push(projectVariable);
        }
      } catch (error) {
        console.error(t('message.ClientProjectDeailAdd.processVariableDataFailed'), error);
      }
    }
    
    if (variablesToBind.length > 0) {
      const bindResult = await batchBindVariables(variablesToBind, tab);
      
      if (bindResult.success) {
        searchVariables();
        ElMessage.success(`${t('message.ClientProjectDeailAdd.successfullyBatchBound')} ${variablesToBind.length} ${t('message.ClientProjectDeailAdd.variablesToProject')}`);
      } else {
        ElMessage.error(bindResult.message || t('message.ClientProjectDeailAdd.batchBindingFailed'));
      }
    }
    
    if (alreadyExistsVariables.length > 0) {
      if (variablesToBind.length === 0) {
        ElMessage.info(`${t('message.ClientProjectDeailAdd.allVariablesExist')}，${t('message.ClientProjectDeailAdd.updatedSuccess')} ${alreadyExistsVariables.length} ${t('message.ClientProjectDeailAdd.variablesInfo')}`);
      } else {
        ElMessage.info(`${alreadyExistsVariables.length} ${t('message.ClientProjectDeailAdd.variablesExist')}，${t('message.ClientProjectDeailAdd.updatedSuccess')}`);
      }
    }
    
    if (variablesToBind.length === 0 && alreadyExistsVariables.length === 0) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.noValidVariables'));
    }
    
    variableDialogVisible.value = false;
    clearAllSelection();
  } else {
    ElMessage.warning(t('message.ClientProjectDeailAdd.selectVariablesFirst'));
  }
};

// 批量绑定变量
const batchBindVariables = async (variables, tab) => {
  try {
    if (!variables || variables.length === 0) {
      return { success: false, message: t('message.ClientProjectDeailAdd.noVariablesToBind') };
    }
    
    const bindData = {
      businessId: formData.business_id || props.businessId,
      projectId: projectId.value,
      companyId: formData.companyId,
      collectionsId: tab.id,
      domainId: tab.domainId,
      deviceId: currentDeviceId.value,
      varInfos: variables.map(variable => ({
        varName: variable.varName,
        mult: variable.mult,
        minimum: variable.minimum,
        maximum: variable.maximum,
        var_default_value: variable.default_value,
        description: variable.description,
        var_group_name: variable.name_group,
        var_sort: 1,
        visible: 1
      }))
    };
    
    const response = await projectAddBindVar(bindData);
    
    if (response.success) {
      return {
        success: true,
        message: `${t('message.ClientProjectDeailAdd.successfullyBatchBound')} ${variables.length} ${t('message.ClientProjectDeailAdd.variables')}`,
        data: response.data
      };
    } else {
      return {
        success: false,
        message: response.msg || t('message.ClientProjectDeailAdd.batchBindingFailed')
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message || t('message.ClientProjectDeailAdd.errorDuringBatchBinding')
    };
  }
};




// ==================== 其他方法 ====================

const addDomain = () => {
  formData.domains.push({
    id: generateId(),
    name: '',
    name_en: '',
    parent_code: null,
    code: ''
  });
};

const addBinding = () => {
  formData.bindings.push({
    id: generateId(),
    domain_id: null,
    device_id: null,
    var_id: null,
    var_type: 1,
    var_group_name: '',
    visible: 1,
    description: ''
  });
};

const openLinkageDialog = (type = 'add') => {
  if (type === 'add') {
    resetCurrentLinkage();
    linkageDialogTitle.value = t('message.ClientProjectDeailAdd.addLinkageRule');
  } else {
    linkageDialogTitle.value = t('message.ClientProjectDeailAdd.editLinkageRule');
  }
 
  linkageDialogVisible.value = true;
  handleLinkSearchVariables();
};


// 从联动变量列表中移除
const handleRemoveLinkageVar = (index) => {
  ElMessageBox.confirm(
    t('message.ClientProjectDeailAdd.confirmRemoveLinkageVariable'),
    t('message.ClientProjectDeailAdd.prompt'),
    {
      confirmButtonText: t('message.ClientProjectDeailAdd.confirm'),
      cancelButtonText: t('message.ClientProjectDeailAdd.cancel'),
      type: 'warning'
    }
  ).then(async () => {
     try
     {
        
            // 获取要删除的变量（splice返回的是数组）
        const deletedItems = currentLinkage.value.linkageVars.splice(index, 1);
        
        if (deletedItems.length === 0) {          
            ElMessage.success(t('message.ClientProjectDeailAdd.linkageVariableRemovedFailed'));
            return;
        } 
        console.error(t('message.ClientProjectDeailAdd.queryVariablesFailed'), deletedItems);
        const linkageVarToDelete = deletedItems[0]; // 获取第一个元素
        const params = {
                          id: linkageVarToDelete.id,
                          projectBindId:linkageVarToDelete.project_info_bind_id,                        
                          DeleteReason:''                          
                       };
    
        const response = await ProjectBindLinkageDelete(params);
        if(response.success)
        {
            ElMessage.success(t('message.ClientProjectDeailAdd.linkageVariableRemoved'));
            currentLinkage.value.linkageVars.value = [];
            searchVariables();
        }
        else
        {
            ElMessage.success(response.message || t('message.ClientProjectDeailAdd.linkageVariableRemovedFailed'));
        }
     }
     catch (error) {
          console.error(t('message.ClientProjectDeailAdd.queryVariablesFailed'), error);
          ElMessage.error(t('message.ClientProjectDeailAdd.linkageVariableRemovedFailed') + ': ' + error.message);
    }
    
        
  }).catch(() => {
    // 用户取消
  });
};

// 查询变量 - 使用新的 projectDeviceVarsList 接口
const handleLinkSearchVariables = async () => {
  try {
    
    
    // 
    const tab = slaveTabs.value.find(t => t.name ===   activeTab.value);
    if (!tab) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.selectModuleFirst'));
      return;
    }
    
    if (!tab.id) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.saveModuleFirst'));
      return;
    }
    
    if (!projectId.value) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.saveProjectFirst'));
      return;
    }

    //ElMessage.error(`${tab.variables[linkageTabCurrentVerIndex.value].deviceId}-${tab.variables[linkageTabCurrentVerIndex.value].deviceCode} handleLinkSearchVariables1`);

    const params = {
      company_id: 0,
      device_code: tab.variables[linkageTabCurrentVerIndex.value].deviceCode,
      name_group:  undefined,
      slave_id: undefined,
      names: variableSearchKeyword.value || undefined,
      businessId: formData.business_id || props.businessId,
      projectId: projectId.value,      
      collectionsId: tab.id,
      domainId: tab.domainId,
      deviceId: tab.variables[linkageTabCurrentVerIndex.value].deviceId,
      pageNum: 1,
      pageSize: 5000
    };
    
    const response = await projectDeviceVarsList(params);
    
    if (response.success) {
      tablePagination.total = response.data.totalCount || 0;
      updateLinkTable(response.data.list || []);
      
      ElMessage.success(`${t('message.ClientProjectDeailAdd.querySuccessfulFound')} ${response.data.list?.length || 0} ${t('message.ClientProjectDeailAdd.variables')}`);
    } else {
      ElMessage.error(response?.msg || t('message.ClientProjectDeailAdd.queryFailed'));
    }
  } catch (error) {
    console.error(t('message.ClientProjectDeailAdd.queryVariablesFailed'), error);
    ElMessage.error(t('message.ClientProjectDeailAdd.queryFailed') + ': ' + error.message);
  }
};

const handleLinkRadioChange = (row) => {
  selectedLinkVariableId.value = row.var_id;
  currentLinkage.value.target_var_id = row.var_id;
  currentLinkage.value.target_device_id = row.deviceId;    
  currentLinkage.value.target_var_value = row.default_value || 0;
  
}
 
//更改默认值
const handleDefaultValueChange = (row, value) => {
    // 1. 更新 alllinkVariables 中的 default_value
  const index = alllinkVariables.value.findIndex(item => item.var_id === row.var_id);
  if (index !== -1) {
    alllinkVariables.value[index].default_value = value;
  }
  
  // 2. 只有当当前行被选中时，才更新 target_var_value
  if (selectedLinkVariableId.value === row.var_id) {
    currentLinkage.value.target_var_value = value;
  }
  
};

const handleLinkVariableRowClick = (row) => {
  selectedLinkVariableId.value = row.var_id
  currentLinkage.value.target_var_id = row.var_id;
  currentLinkage.value.target_device_id = row.deviceId;    
  currentLinkage.value.target_var_value = row.default_value || 0;
}

// 计算属性：过滤后的变量列表
const filteredLinkVariables = computed(() => {
  if (!variableSearchKeyword.value) {
    return alllinkVariables.value
  }
  const keyword = variableSearchKeyword.value.toLowerCase()
  return alllinkVariables.value.filter(variable =>     
    variable.varName?.toLowerCase().includes(keyword)
  )
})

// 更新表格数据 - 适配新的数据结构
const updateLinkTable = (data) => {
  const transformedData = data.map(item => ({
    var_id: item.var_id,
    deviceId: item.device_id, 
    deviceCode: item.device_code,
    deviceName: item.device_name,
    varName: item.var_name,
    display_name: item.display_name || item.var_name,
    name_group: item.name_group,
    description: item.description,
    slaveName: item.slave_name,
    varType: item.var_type,
    rw_type: item.rw_type,
    rw_type_id: item.rw_type_id,
    mult: item.mult || 1,
    minimum: item.minimum,
    maximum: item.maximum,
    var_decimal: item.var_decimal,
    default_value: item.default_value,
    unit: item.unit || '',
    gateway_imei: item.gateway_imei
  }));
  
  alllinkVariables.value = transformedData;
};

  
const saveLinkage = async () => {
  try {

    // 检查是否已有联动变量
    if (currentLinkage.value.linkageVars && currentLinkage.value.linkageVars.length > 0) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.removeLinkagedVariable'));
      return;
    }

    //表单验证
    linkageFormRef.value?.validate((valid) => {
      if (!valid) {
        return false;
      }
    })

    const param = {
      type: 1,                                  /// 联动类型：1.固定值下发；2.多变量联动；3.公式计算
      math: '',
      formula:  '',                             /// 计算公式（当type=3时使用）
      condition_type: 1,                        /// 触发条件类型：1.立即执行 2.延迟执行 3.条件满足执行
      delay_seconds: 0,
      condition_expression: '',      
      project_info_bind_id: currentLinkage.value.project_info_bind_id,  //绑定表的ID
      target_var_id:currentLinkage.value.target_var_id,
      target_device_id:currentLinkage.value.target_device_id,  /// 目标设备ID
      target_var_value:currentLinkage.value.target_var_value,
                mult:1,
             minimum:-100,
             maximum:99999,
      var_cmd_switch:1,
     execution_order:0,
         status: 1,
         description:''
    };

    const response = await  ProjectBindLinkageAdd(param);

    
    if (response.success) {      
      ElMessage.success(response?.msg || t('message.common.addSuccess'));
    } else {
      ElMessage.error(response?.msg || t('message.common.submitError'));
    }

    linkageDialogVisible.value = false;
    resetCurrentLinkage();
    searchVariables();

  } catch (error) {
    console.error(t('message.ClientProjectDeailAdd.validationFailed'), error);
  }
};

const generateId = () => {
  return Date.now() + Math.random().toString(36).substr(2, 9);
};

const updateDomainList = () => {
  domainList.value = formData.domains.map((domain, index) => ({
    id: domain.id,
    name: domain.name || `${t('message.ClientProjectDeailAdd.functionBlock')}${index + 1}`,
    code: domain.code || `${index + 1}`
  }));
};

const resetCurrentLinkage = () => {
  Object.assign(currentLinkage, {
    id: null,
    type: 1,
    condition_type: 1,
    project_info_bind_id:0,
    target_device_id:0,
    target_var_value:0,
    target_var_id: 0,
    delay_seconds: 0,
    condition_expression: '',
    action_content: '',
    action_formula: '',
    description: '',
    editingIndex: null
  });
};

const submitForm = async () => {
  if (!formRef.value) return;
  
  try {
    await formRef.value.validate();
    
    const invalidSlaves = slaveTabs.value.filter(tab => !tab.label || !tab.domainId);
    if (invalidSlaves.length > 0) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.completeAllModules'));
      return;
    }
    
    //if (!projectId.value) {
      const projectResult = await saveProject();
      if (!projectResult.success) {
        return;
      }
    //}
    
    for (const tab of slaveTabs.value) {
      if (!tab.id) {
        const collectionResult = await saveProjectCollection(tab);
        if (!collectionResult.success) {
          return;
        }
      }
    }
    
    submitting.value = true;
    
    resetForm();
    emit('save-success');
    
  } catch (error) {
    console.error(t('message.ClientProjectDeailAdd.formValidationFailed'), error);
    ElMessage.error(t('message.ClientProjectDeailAdd.checkFormData'));
  } finally {
    submitting.value = false;
  }
};

const formatDeviceTree = (treeData) => {
  return treeData.map((item) => {
    const node = {
      id: item.id,
      name: item.name,
      type: item.type,
      key: item.key,
      deviceCode: item.data?.device_code || "",
      parentId: item.parentId,
      parentKey: item.parentKey,
    };

    if (item.children && item.children.length > 0) {
      node.children = formatDeviceTree(item.children);
    }

    return node;
  });
};

const loadDeviceTree = async () => {
  try {
    const params = { companyId: formData.companyId };
    const res = await getCompanyDeviceTree(params);

    if (res.success) {
      deviceList.value = res.data.list;

      deviceTreeOptions.value = res.data.list?.length
        ? formatDeviceTree(res.data.list)
        : [];

      if (deviceTreeOptions.value.length === 0) {
        // 可选的警告信息
      }
    } else {
      ElMessage.error(res.msg || t('message.ClientProjectDeailAdd.loadDeviceTreeFailed'));
    }
  } catch (error) {
    ElMessage.error(t('message.ClientProjectDeailAdd.loadDeviceTreeFailed'));
  }
};

// 获取业务类型标签
const LoadCtCollections = async () => {
  try {
    if(props.projectId<=0)
       return;
    const params = {
      projectId: Number(props.projectId),      
      businessId: Number(props.businessId),
      companyId: formData.companyId,
      name: undefined,
      pageNum: 1,
      pageSize: 1000,
    };

    const res = await projectCollections(params);
    if(!res.success) {
      ElMessage.error(res?.msg);  
      return;
    }
    
    // 检查是否有数据
    if (!res.data.list || res.data.list.length === 0) {
      ElMessage.warning(t('message.ClientProjectDeailAdd.noBusinessData'));
      return;
    }
    slaveTabs.value = res.data.list.map(item => ({
      id: item.id,
      label: item.name,
      name: item.name,
      domainId: 2,
      variables:[]
    }));   
    if(slaveTabs.value.length>0)
    {
        activeTab.value = slaveTabs.value[0].name;
    }
    
    await searchVariables();
  } catch (error) {
    console.error(t('message.ClientProjectDeailAdd.loadBusinessFailed'), error);
    ElMessage.error(t('message.ClientProjectDeailAdd.loadBusinessFailed'));
  } 
}

const previewConfig = () => {
  const config = {
    [t('message.ClientProjectDeailAdd.moduleCount')]: formData.name,
    [t('message.ClientProjectDeailAdd.functionBlockCount')]: businessList.value.find(b => b.id === formData.business_id)?.name || t('message.ClientProjectDeailAdd.notSelected'),
    [t('message.ClientProjectDeailAdd.variableBindingCount')]: formData.location,
    [t('message.ClientProjectDeailAdd.linkageRuleCount')]: formData.description
  };
  
  console.log(t('message.ClientProjectDeailAdd.configPreview') + ':', config);
  ElMessage.info(t('message.ClientProjectDeailAdd.configPreviewConsole'));
};

const resetForm = () => {
  if (!formRef.value) return;
  
  formRef.value.resetFields();
  formData.domains = [];
  formData.bindings = [];
  formData.linkages = [];
  selectedDomains.value = [];
  selectedBindings.value = [];
  selectedLinkages.value = [];
  
  initializeSlaveTabs();  
  activeConfigTab.value = 'domains';  
  projectId.value = 0;
  projectCollectionsId.value = 0;
};


//加载Domain
const LoadDomainLabel = async () => {
  try {
    const params = {
      all: 1,          //1为查询所有，其它为按条件查
      projectId: 0,
      collectionId:0,
      businessId: 0,
      companyId: formData.companyId,
      name: undefined,
      pageNum: 1,
      pageSize: 10000,
    };

    const res = await projectDomainList(params);
    if(!res.success) {
      ElMessage.error(res?.msg);  
      return;
    }
    
    // 检查是否有数据
    if (!res.data.list || res.data.list.length === 0) {      
      //ElMessage.warning(t('message.ClientProjectMonitorSystemMonitoring.noData'));
      return;
    }
    
    domainOptions.value = res.data.list.map(item => ({
      value: item.id, // 确保是字符串类型
      label: item.name
    }));    
  } catch (error) {
    console.error('加载业务选项失败:', error);
    ElMessage.error(t('message.ClientProjectMonitorSystemMonitoring.loadFailed'));
  } 
}

const loadCompanyTree = async () => {
  try {
    const res = await getCompanyTree(queryCompanyTreeParams);
    companyTreeData.value = res.data.list;

    if (companyTreeData.value.length > 0) {      
     // formData.companyId = companyTreeData.value[0].id;
    }
  } catch (error) {
    ElMessage.error(t("message.device.loadCompanyFailed"));
  }
};


// 页面加载时初始化
onMounted(async () => {
  
  // 初始化表格高度
  calculateTableHeight();
  // 监听窗口大小变化
  window.addEventListener('resize', handleResize);
  await LoadDomainLabel();
  initializeSlaveTabs();
  
  addDomain();
  addBinding();
  updateDomainList();
  
  tabsReady.value = true;

  businessList.value = [{ id: props.businessId, name: props.businessName, code: props.businessName } ];
  formData.business_id = props.businessId;      
  formData.companyId= props.companyId;      
  formData.currentProjectAddOrEdit = props.currentProjectAddOrEdit;
  if (props.projectId>0 ) {    
    formData.name = props.projectName;
    projectId.value = props.projectId>0 ?  props.projectId : projectId.value  
    LoadCtCollections();
  }
  //ElMessage.error(`${ formData.currentProjectAddOrEdit} 的编辑功能正在建设中`);
  await loadCompanyTree();
  await loadDeviceTree();
});

// 组件卸载时移除监听器
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<style scoped>
/* 项目容器 */
.project-create-container {
  padding: 0px;
  background: #f5f7fa;  
  height: 100%;  
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* 卡片样式调整 */
:deep(.el-card) {
  display: flex;
  flex-direction: column;
  height: 100%;
}

:deep(.el-card__body) {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* 表单区域 - 使用三部分布局 */
.project-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
  max-width: 100%;
  margin: 0 auto;
}

/* 顶部：基本信息区域 */
.form-top-section {
  flex-shrink: 0;
  background: #fff;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 中间：Tab和表格区域 */
.form-middle-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 底部：按钮区域 */
.form-bottom-section {
  flex-shrink: 0;
  background: #fff;
  padding: 0px;
  border-radius: 4px;
  border-top: 2px solid #409eff;
  position: relative;
  z-index: 10;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.1);
}

/* 确保按钮可见 */
.form-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 10px 0;
}

.form-footer .el-button {
  min-width: 120px;
  padding: 10px 25px;
  font-size: 14px;
  font-weight: 500;
}

/* Tabs区域调整 */
.slave-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

:deep(.el-tabs__content) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

:deep(.el-tab-pane) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 参数模块配置区域 */
.slave-config {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: #f8fafc;
  border-radius: 4px;
  padding: 15px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
}

/* 配置头部 */
.config-header {
  flex-shrink: 0;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}

/* 操作按钮区域 */
.action-buttons {
  flex-shrink: 0;
  margin: 15px 0;
}

.action-buttons .el-col {
  display: flex;
  align-items: center;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.search-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: 10px;
}

.search-group .search-input {
  flex: 1;
  min-width: 0;
  max-width: 200px;
}

.search-group .search-button {
  flex-shrink: 0;
}

/* 表格主区域 */
.table-main-area {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  border: 1px solid #ebeef5;
}

/* 变量表格容器 */
.variable-table-container {
  flex: 1;
  min-height: 150px;
  overflow: hidden;
}

/* 变量表格 */
.variable-table {
  height: 100%;
  width: 100%;
}

/* 分页区域 */
.table-footer {
  flex-shrink: 0;
  margin-top: 15px;
  padding: 12px 0;
  border-top: 1px solid #ebeef5;
  background: #fff;
}

.variable-pagination {
  margin: 0;
}


/* 联动变量列表样式 */
.linkage-vars-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 150px;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f5f7fa;
}

.linkage-var-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  transition: all 0.3s;
}

.linkage-var-item:hover {
  background-color: #ecf5ff;
  border-color: #409eff;
}

.linkage-var-item .var-name {
  font-size: 14px;
  color: #606266;
  flex: 1;
}

.linkage-var-item .remove-btn {
  flex-shrink: 0;
  margin-left: 10px;
}

.no-bound-variable {
  color: #c0c4cc;
  font-style: italic;
  padding: 8px;
  text-align: center;
}

/* 表格中的操作按钮 */
:deep(.el-table .cell) {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 确保删除按钮在鼠标悬停时更明显 */
.linkage-var-item .remove-btn:hover {
  background-color: #f56c6c;
  color: white;
}

/* 响应式设计 - 针对不同屏幕高度 */
@media (max-height: 900px) {
  .form-top-section {
    padding: 12px;
  }
  
  .form-middle-section {
    padding: 12px;
  }
  
  .slave-config {
    padding: 12px;
  }
  
  .table-main-area {
    padding: 12px;
  }
}

@media (max-height: 800px) {
  .form-top-section {
    padding: 10px;
    margin-bottom: 8px;
  }
  
  .form-middle-section {
    padding: 10px;
    margin-bottom: 8px;
  }
  
  .form-bottom-section {
    padding: 12px;
  }
  
  .slave-config {
    padding: 10px;
  }
  
  .table-main-area {
    padding: 10px;
  }
  
  .action-buttons {
    margin: 10px 0;
  }
  
  .config-header {
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  
  .table-footer {
    margin-top: 12px;
    padding: 10px 0;
  }
}

@media (max-height: 700px) {
  .form-top-section {
    padding: 8px;
  }
  
  .form-middle-section {
    padding: 8px;
  }
  
  .form-bottom-section {
    padding: 10px;
  }
  
  .slave-config {
    padding: 8px;
  }
  
  .table-main-area {
    padding: 8px;
  }
  
  .variable-table-container {
    min-height: 120px;
  }
  
  .form-footer {
    padding: 8px 0;
  }
  
  .form-footer .el-button {
    min-width: 100px;
    padding: 8px 20px;
    font-size: 13px;
  }
}

@media (max-height: 600px) {
  .form-top-section {
    padding: 6px;
  }
  
  .form-middle-section {
    padding: 6px;
  }
  
  .form-bottom-section {
    padding: 8px;
  }
  
  .slave-config {
    padding: 6px;
  }
  
  .table-main-area {
    padding: 6px;
  }
  
  .variable-table-container {
    min-height: 100px;
  }
  
  .action-buttons {
    margin: 8px 0;
  }
  
  .button-group .el-button {
    padding: 5px 10px;
    font-size: 12px;
  }
  
  .search-group .search-input {
    max-width: 150px;
  }
  
  .form-footer .el-button {
    min-width: 90px;
    padding: 6px 15px;
    font-size: 12px;
  }
}

/* 针对小宽度屏幕 */
@media (max-width: 1200px) {
  .search-group {
    flex-wrap: wrap;
  }
  
  .search-group .search-input {
    max-width: 180px;
  }
}

@media (max-width: 992px) {
  .action-buttons .el-col {
    width: 100% !important;
    margin-bottom: 10px;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-group {
    justify-content: flex-start;
  }
  
  .button-group {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  
  .form-footer {
    flex-wrap: wrap;
    gap: 10px;
  }
}

@media (max-width: 768px) {
  .search-group {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  
  .search-group .search-input {
    max-width: 100%;
  }
  
  .search-group .search-button {
    width: 100%;
  }
  
  .button-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .button-group .el-button {
    width: 100%;
    margin-bottom: 5px;
  }
  
  .form-footer {
    flex-direction: column;
    align-items: stretch;
  }
  
  .form-footer .el-button {
    width: 100%;
    margin-bottom: 8px;
  }
}

/* 确保在非常小的屏幕上底部按钮始终可见 */
@media (max-height: 500px) {
  .form-bottom-section {
    position: sticky;
    bottom: 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
  }
  
  .project-form {
    overflow-y: auto;
    padding-bottom: 70px; /* 为底部按钮留出空间 */
  }
}

/* 确保Element Plus表格正确显示 */
:deep(.el-table) {
  height: 100%;
}

:deep(.el-table__body-wrapper) {
  overflow: auto;
}

/* 确保Tabs正确显示 */
:deep(.el-tabs__header) {
  margin: 0;
}

:deep(.el-tabs__nav-wrap) {
  padding: 0 15px;
}

/* 对话框样式 */
.dialog-content-wrapper {
  height: 100%;
  overflow-y: auto;
  padding-right: 10px;
}

.section-header {
  margin-bottom: 20px;
}

.section-title {
  font-weight: bold;
  font-size: 16px;
  color: #409eff;
}

.search-form {
  margin-bottom: 20px;
}

.table-operations {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.left-operations,
.right-operations {
  display: flex;
  gap: 10px;
  align-items: center;
}

.variable-dialog-table {
  margin-top: 10px;
}

.variable-dialog-table :deep(.el-table__body-wrapper) {
  max-height: 400px;
}

.column-header {
  display: flex;
  align-items: center;
  gap: 4px;
}

.header-icon {
  font-size: 12px;
  color: #909399;
  cursor: help;
}

.default-name {
  color: #909399;
  font-style: italic;
}

.no-description {
  color: #c0c4cc;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  padding: 10px 0;
}

.selected-count {
  color: #606266;
}

.count-number {
  color: #409eff;
  font-weight: bold;
}

.dialog-pagination {
  margin: 0;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.footer-left {
  color: #409eff;
  font-weight: 500;
}

.selected-info {
  background-color: #ecf5ff;
  padding: 4px 12px;
  border-radius: 4px;
}

.footer-right {
  display: flex;
  gap: 10px;
}

/* 对话框自定义样式 */
:deep(.variable-dialog.el-dialog) {
  height: 85vh; /* 使用视口高度百分比 */
  max-height: 800px; /* 最大高度限制 */
  min-height: 500px; /* 最小高度限制 */
  display: flex;
  flex-direction: column;
}

:deep(.variable-dialog .el-dialog__body) {
  flex: 1;
  padding: 20px;
  overflow: hidden; /* 防止内容溢出 */
  display: flex;
  flex-direction: column;
}

.dialog-content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 表格容器 */
.variable-dialog-table {
  flex: 1;
  min-height: 300px;
}

:deep(.variable-dialog-table .el-table__body-wrapper) {
  max-height: calc(85vh - 400px); /* 动态计算表格高度 */
  overflow-y: auto;
}

.filter-control {
  flex: 1;
  min-width: 180px;
}

.filter-control:deep(.el-cascader .el-input__inner) {
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  display: flex;
  align-items: center;
}

.variable-selector:deep(.selector-header) {
  height: 32px;
  min-height: 32px;
  line-height: 32px;
  padding: 0 12px;
  display: flex;
  align-items: center;
}
</style>